document.res_de = {
	// ── PL.tip: die Kopfzeile der Hinweisbox wird im JS gebaut (früher #{global.tip}) ──
	tipHeader_title: "Tipp",
	// das × der Hinweisbox im geführten Modus (js/pl/tip.js) — nur aria-label
	tipClose_label: "Schließen",
	touchRotateHint_body: "Drehen Sie das Tablet ins Querformat: Dann passt eine Seitenleiste neben die Seite.",
	touchRotateHintClose_label: "Schließen",
	// ── Touch layer: the tap copy (tablet-support-plan.md §7b, S7) ──
	// js/touch/copy.js reads <key>_touch in place of <key> on a touch device (seam T-16, util.js
	// getRes). Same meaning, the finger's verb; a line that offered Enter/Esc as the other way drops it.
	obTourWlAdd_body_touch: "Auf diese Schaltfläche tippen und eine Liste wählen — das Wort landet direkt in der ausgewählten Liste. Mit Wortlisten sammeln Sie genau die Wörter, die Sie lernen und üben möchten.",
	obTourMyList_body_touch: "Hier stehen alle Wörter und Wendungen, die Sie Ihrer Wortliste hinzugefügt haben. Zum Öffnen einfach antippen.",
	obTourBandAdd_body_touch: "Jede Liste hat einen: Er legt Wörter aus der Liste in Ihre Ablage. Einfach antippen.",
	obTourBandFive_body_touch: "Auf den kleinen Pfeil neben der 5 tippen — fünf zufällige Wörter werden ausgewählt.",
	obWlOffer_body_touch: "Jetzt kann es losgehen — auf „Lernen starten!“ tippen und die neuen Wörter lernen.\n\nDoch bevor es weitergeht: Ein genauerer Blick auf die Wortlisten lohnt sich. Dort gibt es viel zu entdecken! Die Wortlisten-Tour können Sie auch später über das Hilfemenü {?} starten.\n\nMöchten Sie die Tour fortsetzen?",
	obWlGarden_body_touch: "Hier wächst jedes eingepflanzte Wort, sortiert danach, wie gut Sie es schon können. Tippen Sie auf Mein Garten, um ihn zu öffnen.",
	obWlLevels_body_touch: "Alle Wörter des Wörterbuchs sind nach Stufen auf Listen verteilt — von den leichtesten bis zu den schwersten. Tippen Sie auf eine Liste, um sie zu öffnen und ihre Wörter zu sehen.",
	obWlTopicPick_body_touch: "Achtzehn Listen hinter einer einzigen Zeile — Essen, Reisen, Arbeit und vieles mehr. Tippen Sie auf die hervorgehobene, um sie zu öffnen.",
	obWlTopicWord_body_touch: "Tippen Sie in einer Wortliste auf ein Wort, um seinen Wörterbucheintrag zu sehen. Probieren Sie es mit dem hervorgehobenen.",
	obWlFilter_body_touch: "Tippen Sie auf die Lupe, um schnell Wörter in allen Wortlisten zu finden.",
	obWlNew_body_touch: "Tippen Sie auf diese Schaltfläche, um eine neue Wortliste anzulegen — sammeln Sie die Wörter dort nach Lektion, nach Lied, nach Thema, ganz wie Sie mögen.",
	obWlNewUse_body_touch: "Wenn Sie das nächste Mal bei einem Wort, das Sie behalten möchten, auf {0} tippen, können Sie es in diese Liste schicken.",
	obMeetReveal_body_touch: "Raten Sie ruhig, und tippen Sie dann auf das Wort, um die Bedeutung zu sehen.",
	obTourRowOpen_touch: "Tippen Sie auf das Wort, um seinen Eintrag zu öffnen — dort ist die Schaltfläche, die es zum Lernen bringt.",
	obMeetEntry_body_touch: "Zu jedem Wort, das Sie kennenlernen, gehört ein vollständiger Wörterbucheintrag – mit Bedeutungen, Grammatik, Beispielen und Aussprache. Die Übersetzung steht oben, alles Weitere darunter. Halten Sie ein Wort oder eine Angabe gedrückt, um zu sehen, was sie bedeutet.",
	obMeetGotIt_body_touch: "Auf „{0}“ tippen, wenn Sie fertig gelesen haben.",
	obTipExpStart_body_touch: "<p>Tippen Sie auf „Lernen starten!“, um Ihre ersten paar Wörter kennenzulernen — für diese erste Einheit zufällig aus Ihrer Stufe ausgewählt. Später wählen Sie die Wörter ganz nach Belieben selbst aus.</p><p>Noch etwas: Während der Tour ist der größte Teil der App absichtlich nicht erreichbar, damit nichts vom einfachsten Weg ablenkt. Danach steht Ihnen selbstverständlich alles offen.</p>",
	obTipExpList_body_touch: "Tippen Sie auf diese Wortliste des Wörterbuchs, um sie zu öffnen.",
	obTipExpChip_body_touch: "Tippen Sie auf diesen Buchstaben, um die einfachste Wortliste des Wörterbuchs zu öffnen.",
	obTipExpAdd_body_touch: "Mit dieser Schaltfläche legen Sie Wörter aus der geöffneten Liste in Ihre Ablage — einfach antippen und die Anzahl wählen.",
	obGuideFive_body_touch: "Auf den kleinen Pfeil tippen, und 3 zufällige Wörter landen in Ihrer Ablage.",
	obGuideFiveNext_body_touch: "Auf den kleinen Pfeil tippen, und 5 zufällige Wörter landen in Ihrer Ablage.",
	obGuideDrill_body_touch: "Auf „Übung starten!“ tippen – eine kurze Übung auf Zeit festigt diese Wörter.",
	obTipSpacePron_body_touch: "Mit der Lautsprecher-Schaltfläche hören Sie die Aussprache des Wortes. Sie erscheint überall dort, wo ein Wort zu hören ist.",
	obTipThirsty_body_touch: "Einige Ihrer Pflanzen sind durstig. Tippen Sie auf den Chip, um genau diese Wörter in die Ablage zu legen – für eine schnelle Gießrunde.",
	learnStudyTerm_tooltip_touch: "Antippen für den vollständigen Wörterbucheintrag",
	learnMeet_reveal_label_touch: "Übersetzung bekannt? Hier tippen, um sie zu zeigen",
	learnQ_pickHint_touch: "Tippen Sie auf die richtige Karte",
	stopButton_tooltip_touch: "Übung beenden und zurück zur Hauptseite",
	phraseBand_pagerRow_tooltip_touch: "Zeilen {0}–{1} von {2} — tippen zum Springen",
	startButton_tooltip_touch: "Tippen und Wörter lernen!",
	practiceDir_mix_tooltip_touch: "Beide Richtungen antippen für eine gemischte Lerneinheit: Jedes Wort läuft in die Richtung, die es beim letzten Mal NICHT hatte<p/>(gleich viele Wörter — eine Karte pro Wort)",
	pauseButton_tooltip_touch: "Tippen, um das Lernen zu pausieren",
	continueButton_tooltip_touch: "Tippen, um weiterzulernen",
	richTerm_tooltip_touch: "Tippen zum Einklappen — oder die Zurück-Taste des Browsers verwenden",
	revealTerm_tooltip_touch: "Tippen öffnet den Wörterbucheintrag",
	pronDialPlay_hint_touch: "tippen zum Anhören",
	wlGarden_tooltip_touch: "Jedes Wort, mit dem Sie wirklich gearbeitet haben — was gegossen werden muss, was begonnen ist und was wächst<p/>Tippen Sie auf die Blüte, um den ganzen Garten zu sehen",
	wlLevelSort_tooltip_touch: "So ist diese Liste sortiert — zum Wechseln tippen",
	wlLevelCompactHint_tooltip_touch: "<p>Doppelt tippen: die Niveau-Zeilen zu einem Streifen zusammenklappen.</p><p>Dort zweimal auf das 📖 tippen, um wieder aufzuklappen.</p><p>Auch über: Kontomenü ▸ Einstellungen ▸ Wortlisten-Einstellungen.</p>",
	wlLevelExpandHint_tooltip_touch: "<p>Doppelt tippen: aufklappen, eine Zeile pro Niveau.</p><p>Zweimal auf das 📖 einer Zeile tippen, um wieder zusammenzuklappen.</p><p>Auf einen Buchstaben tippen, um diese Liste zu öffnen.</p><p>Auch über: Kontomenü ▸ Einstellungen ▸ Wortlisten-Einstellungen.</p>",
	wlVerbCompactHint_tooltip_touch: "<p>Doppelt tippen: die Verb-Zeilen zu einem Streifen zusammenklappen.</p><p>Dort zweimal auf das 📝 tippen, um wieder aufzuklappen.</p><p>Auch über: Kontomenü ▸ Einstellungen ▸ Wortlisten-Einstellungen.</p>",
	wlVerbExpandHint_tooltip_touch: "<p>Doppelt tippen: aufklappen, eine Zeile pro Liste.</p><p>Zweimal auf das Symbol einer Zeile tippen, um wieder zusammenzuklappen.</p><p>Auf ein Symbol tippen, um diese Liste zu öffnen.</p><p>Auch über: Kontomenü ▸ Einstellungen ▸ Wortlisten-Einstellungen.</p>",
	richTopicHint_tooltip_touch: "(tippen, um die Wortliste zu diesem Thema zu öffnen)",
	knownToggle_tooltip_touch: "Diese Bedeutung als bereits bekannt markieren — Übungen überspringen sie (erneut tippen zum Rückgängigmachen)",
	exGroup_recalled_tooltip_touch: "Diese Wörter haben Sie so wiedergegeben, wie Sie es selbst mit dem Regler für den Strengegrad festgelegt haben. Tippen Sie auf die Wörter, um diese Schwelle anzusehen oder zu ändern — sie allein entscheidet, in welche Gruppe ein Wort fällt.",
	exGroup_notRecalled_tooltip_touch: "Diese Wörter kamen nicht so zurück, wie Sie es selbst mit dem Regler für den Strengegrad festgelegt haben. Nichts geht verloren, und keine Pflanze schrumpft je — sie kommen einfach früher wieder. Tippen Sie auf die Wörter, um diese Schwelle anzusehen oder zu ändern.",
	garden_stats_click_hint_touch: "Tippen für die Statistik zu diesem Wort",
	garden_grow_open_touch: "Tippen, um den ganzen Garten zu sehen",
	garden_thirsty_tooltip_touch: "Zum Gießen fällige Wörter<p/>Tippen, um sie in die Trainingsablage zu legen",
	garden_vista_click_hint_touch: "Tippen für den vollständigen Eintrag",
	hist_tip_word_touch: "Das Wort, um das es in dieser Zeile geht. Tippen Sie auf die Zeile, um den vollständigen Lernverlauf zu sehen.",
	hist_ws_tip_word_touch: "Das Wort, um das es in dieser Zeile geht. Für die vollständige Historie auf die Zeile tippen.",
	hist_wh_tip_when_touch: "Die Lerneinheit, die dieses Wort abgefragt hat — mit Tag und Startzeit. Auf die Zeile tippen, um sie zu öffnen.",
	hist_acc_hard_sub_touch: "niedrigste Genauigkeit unter den Wörtern, die mindestens {0}-mal gezeigt wurden – für die ganze Historie auf ein Wort tippen",
	// ── end of the tap copy ──
	tipMakeSmall_label: "Erklärungen verkleinern",
	tipMakeLarge_label: "Erklärungen vergrößern",
	// ── Onboarding: die geführte erste Sitzung (js/onboarding.js) ──
	obWelcome_title: "Willkommen!",
	obWelcomeLang_label: "Ich spreche:",
	obLevelRow_label: "Ihr Niveau:",
	obWelcomeBack_tooltip: "Zurück zur Startseite – um eine andere Sprache zu wählen",
	obWelcome_body: "Eine kurze geführte Tour: Zuerst lernen Sie ein paar Wörter kennen, dann sorgt der Tab „Training“ dafür, dass sie hängen bleiben. Nur drei Minuten. Keine Anmeldung nötig.",
	obLevel_label: "Wie viel können Sie schon?",
	obLevelA_button: "Ich fange gerade mit {0} an",
	obLevelB_button: "Ich kann einfache Gespräche führen",
	obLevelC_button: "Ich kann schon einiges, möchte aber meinen Wortschatz erweitern",
	obMeet_button: "Kurze geführte Tour",
	obMeet_loading: "Ihre ersten Wörter werden geladen…",
	obExplore_button: "Lieber selbst erkunden",
	obGotIt_button: "Alles klar",
	obBeatBed_title: "Eingepflanzt!",
	obBeatBed_body: "Ihre Wörter sind jetzt in Ihrem Garten. Morgen werden sie durstig — schauen Sie wieder vorbei und gießen Sie sie.",

	// ── Onboarding: die Tour nach der ersten abgeschlossenen Übung (js/onboarding_guide.js) ──
	obTourProgress_title: "Ihr Fortschritt",
	obTourProgress_body: "Diese Anzeige hält den Verlauf über die Zeit fest — beherrschte Wörter, wie treffsicher Sie sind, wie viel schon gelernt wurde.",
	obTourBack_title: "Fertig mit diesen Wörtern",
	obTourBack_body: "Mit „Zurück zu Wörtern“ verlassen Sie die Lerneinheit und können auswählen, was als Nächstes drankommt.",
	obTourDict_title: "Das Wörterbuch",
	obTourDict_body: "Zu allem, was sich hier lernen lässt, gibt es einen Eintrag — öffnen Sie das Wörterbuch.",
	obTourLookup_title: "Ein Wort nachschlagen",
	// {0} = die gelernte Sprache, {1} = ein Wort, das es im Wörterbuch WIRKLICH gibt
	obTourLookup_body: "Geben Sie ein Wort ein, das Sie in {0} nachschlagen möchten, zum Beispiel {1}, und drücken Sie Enter.",
	obTourLookupPlain_body: "Geben Sie ein Wort ein, das Sie in {0} nachschlagen möchten, und drücken Sie Enter.",
	obTourWlAdd_title: "Zu einer Wortliste hinzufügen",
	obTourWlAdd_body: "Auf diese Schaltfläche klicken und eine Liste wählen — das Wort landet direkt in der ausgewählten Liste. Mit Wortlisten sammeln Sie genau die Wörter, die Sie lernen und üben möchten.",
	obTourMyList_title: "Ihre Liste",
	obTourMyList_body: "Hier stehen alle Wörter und Wendungen, die Sie Ihrer Wortliste hinzugefügt haben. Zum Öffnen einfach anklicken.",
	obTourRowAdd_title: "Ab zum Lernen",
	obTourRowAdd_body: "Diese Schaltfläche legt das Wort in die Lern-Ablage — bereit für die nächste Einheit.",
	obTourBand_title: "Noch ein paar dazu",
	obTourBand_body: "Ein einziges Wort ergibt eine magere Lerneinheit — öffnen Sie die markierte Liste, die Ihrer Stufe, und nehmen Sie gleich eine Handvoll zufälliger Wörter dazu, um sie gemeinsam zu lernen. Später können Sie auch jedes einzelne Wort gezielt auswählen.",
	obTourBandAdd_title: "Der Hinzufügen-Knopf",
	obTourBandAdd_body: "Jede Liste hat einen: Er legt Wörter aus der Liste in Ihre Ablage. Einfach anklicken.",
	obTourBandRandom_title: "Die Liste wählen lassen",
	obTourBandRandom_body: "„Zufällig“ zieht eine bunt gemischte Handvoll heraus — der schnellste Weg zu einer vollen Lerneinheit.",
	obTourBandFive_title: "5 auf einmal",
	obTourBandFive_body: "Auf den kleinen Pfeil neben der 5 klicken — fünf zufällige Wörter werden ausgewählt.",
	obTourBandAppend_title: "Vorhandenes behalten",
	obTourBandAppend_body: "In Ihrer Ablage liegt bereits ein Wort. Wählen Sie die zweite Option — sie fügt die neuen hinzu und behält das vorhandene.",

	// ── Onboarding: das Wortlisten-Kapitel (nach der ersten Hälfte der Tour angeboten) ──
	obWlOffer_title: "Bereit zum Lernen",
	obWlOffer_body: "Jetzt kann es losgehen — auf „Lernen starten!“ klicken und die neuen Wörter lernen.\n\nDoch bevor es weitergeht: Ein genauerer Blick auf die Wortlisten lohnt sich. Dort gibt es viel zu entdecken! Die Wortlisten-Tour können Sie auch später über das Hilfemenü {?} starten.\n\nMöchten Sie die Tour fortsetzen?",
	obWlOfferNo_button: "Nein, ich mache allein weiter",
	obWlOfferYes_button: "Ja, bitte — Wortlisten zeigen",
	obWlPanel_title: "Ihre Wortlisten",
	obWlPanel_body: "Dieser Bereich ist Ihre Bibliothek: fertige Listen aus dem Wörterbuch und die Listen, die Sie selbst anlegen.",
	obWlGarden_title: "Mein Garten",
	obWlGarden_body: "Hier wächst jedes eingepflanzte Wort, sortiert danach, wie gut Sie es schon können. Klicken Sie auf Mein Garten, um ihn zu öffnen.",
	obWlGardenAuto_title: "Füllt sich von selbst",
	obWlGardenAuto_body: "Die Wörter, die Sie gerade lernen, landen hier automatisch — Sie müssen sie nie selbst hinzufügen.",
	obWlLevels_title: "Nach Häufigkeit",
	obWlLevels_body: "Alle Wörter des Wörterbuchs sind nach Stufen auf Listen verteilt — von den leichtesten bis zu den schwersten. Klicken Sie auf eine Liste, um sie zu öffnen und ihre Wörter zu sehen.",
	obWlTopics_title: "Nach Thema",
	obWlTopicPick_body: "Achtzehn Listen hinter einer einzigen Zeile — Essen, Reisen, Arbeit und vieles mehr. Klicken Sie auf die hervorgehobene, um sie zu öffnen.",
	obWlTopicWord_title: "Direkt zum Eintrag",
	obWlTopicWord_body: "Klicken Sie in einer Wortliste auf ein Wort, um seinen Wörterbucheintrag zu sehen. Probieren Sie es mit dem hervorgehobenen.",
	obWlFilter_title: "Wort finden",
	obWlFilter_body: "Klicken Sie auf die Lupe, um schnell Wörter in allen Wortlisten zu finden.",
	obWlFilterBox_title: "Tippen zum Suchen",
	obWlFilterBox_body: "Tippen Sie ein paar Buchstaben in das Suchfeld — gesucht wird in allen Listen gleichzeitig, und die Zahl neben einer Liste zeigt, wie viele ihrer Wörter passen. Klicken Sie auf die Liste, um sie zu sehen. Versuchen Sie es mit einem Wort aus einer bereits abgeschlossenen Lektion — Sie finden es wahrscheinlich in mehreren Listen zugleich.",
	obWlMine_title: "Meine Liste",
	obWlMine_body: "⭐ Ein Wort, das Sie aus dem Wörterbuch speichern, kommt in die Liste Ihrer Wahl — „Meine Liste“ gibt es von Anfang an, eigene Listen können Sie aber ebenfalls anlegen.",
	obWlNew_title: "Eigene Liste anlegen",
	obWlNew_body: "Klicken Sie auf diese Schaltfläche, um eine neue Wortliste anzulegen — sammeln Sie die Wörter dort nach Lektion, nach Lied, nach Thema, ganz wie Sie mögen.",
	obWlNewName_title: "Namen vergeben",
	obWlNewName_body: "Tippen Sie den gewünschten Namen ein und drücken Sie die Eingabetaste.",
	// {0} = das Symbol „zur Liste hinzufügen“, inline
	obWlNewUse_title: "Wo sie auftaucht",
	obWlNewUse_body: "Wenn Sie das nächste Mal bei einem Wort, das Sie behalten möchten, auf {0} klicken, können Sie es in diese Liste schicken.",
	obSignReplay_title: "Jetzt sind Sie dran",
	obSignReplay_body: "<p>Schlagen Sie jedes Wort nach, legen Sie eigene Listen an, lassen Sie Ihren Garten wachsen. Vor allem aber: Tippen Sie Ihre Wörter unter „Training“ — was Sie selbst abrufen, bleibt.</p><p>Die Tour finden Sie jederzeit wieder hier im Menü.</p>",

	obTourQuit_title: "Tour läuft noch",
	obTourQuit_body: "Die übrigen Bedienelemente schlafen, solange die geführte Tour läuft. Möchten Sie die Tour beenden und die Anwendung auf eigene Faust erkunden? Sie können die Tour jederzeit über das Hilfemenü {?} neu starten.",
	obTourQuitYes_button: "Ja, Tour beenden",
	obTourQuitNo_button: "Nein, Tour fortsetzen",
	obTourQuitRestart_button: "Tour von vorn beginnen",
	obBack_button: "Zurück",
	obContinue_button: "Weiter",
	obDoorPractice_title: "Direkt zum Training?",
	obDoorPractice_body: "Möchten Sie direkt zum Training wechseln? Die Tour geht dort weiter.",
	obDoorPracticeStay_button: "Nein, beim Lernen bleiben",
	obDoorPracticeGo_button: "Ja, zum Training",
	obDoorDict_title: "Das Wörterbuch erkunden?",
	obDoorDict_body: "Das beendet die Tour — Sie können sie jederzeit über das Hilfemenü {?} neu starten.",
	obDoorDictStay_button: "Zurück",
	obDoorDictGo_button: "Erkunden",
	obRecommended_hint: "(Empfohlen)",

	// ── Onboarding: die Eintragstour auf der ersten Kennenlernkarte (js/onboarding_guide.js) ──
	obMeetReveal_title: "Ihr erstes Wort",
	obMeetReveal_body: "Raten Sie ruhig, und klicken Sie dann auf das Wort – oder drücken Sie Enter –, um die Bedeutung zu sehen.",
	obMeetEntry_title: "Das ganze Wort",
	obMeetEntry_body: "Zu jedem Wort, das Sie kennenlernen, gehört ein vollständiger Wörterbucheintrag – mit Bedeutungen, Grammatik, Beispielen und Aussprache. Die Übersetzung steht oben, alles Weitere darunter.",
	// {0} = die Weiter-Schaltfläche der Kennenlernkarte
	obMeetGotIt_title: "Weiter",
	obMeetGotIt_body: "Auf „{0}“ klicken, wenn Sie fertig gelesen haben.",
	obMeetNext_title: "Sie sind dran",
	obMeetNext_body: "Folgen Sie einfach den Hinweisen auf dem Bildschirm, um Ihre ersten paar Wörter mit Parlevi weiterzulernen.",

	// ── Onboarding: Hinweis-Beacons (js/onboarding_tips.js) ──
	obTipExpLearn_title: "Hier geht's los",
	obTipExpLearn_body: "Neue Wörter lernen Sie im Tab „Lernen“ kennen. Nehmen Sie sich ein paar aus den Wortlisten links, dann kann es losgehen.",
	obTipExpStart_title: "Wörter kennenlernen",
	obTipExpStart_body: "<p>Klicken Sie auf „Lernen starten!“, um Ihre ersten paar Wörter kennenzulernen — für diese erste Einheit zufällig aus Ihrer Stufe ausgewählt. Später wählen Sie die Wörter ganz nach Belieben selbst aus.</p><p>Noch etwas: Während der Tour ist der größte Teil der App absichtlich nicht erreichbar, damit nichts vom einfachsten Weg ablenkt. Danach steht Ihnen selbstverständlich alles offen.</p>",
	obTipExpDrill_title: "Alles bereit",
	obTipExpDrill_body: "Ihre Wörter haben es geschafft. Nehmen Sie sie mit ins Training — eine kurze Übung festigt sie.",
	obTipExpList_title: "Wortliste öffnen",
	obTipExpList_body: "Klicken Sie auf diese Wortliste des Wörterbuchs, um sie zu öffnen.",
	obTipExpChip_body: "Klicken Sie auf diesen Buchstaben, um die einfachste Wortliste des Wörterbuchs zu öffnen.",
	obTipExpAdd_title: "Wörter hinzufügen",
	obTipExpAdd_body: "Mit dieser Schaltfläche legen Sie Wörter aus der geöffneten Liste in Ihre Ablage — einfach klicken und die Anzahl wählen.",
	obTipExpTray_title: "Ihre Wörter warten",
	obTipExpTray_body: "Die ausgewählten Wörter liegen in Ihrer Ablage im Tab „Lernen“ — bereit, sobald Sie es sind.",

	// ── Onboarding: die Menü-Schritte des Leucht-Guides (js/onboarding_guide.js) ──
	obGuideRandom_title: "Die Liste wählt aus",
	obGuideRandom_body: "„Zufall“ zieht eine bunte Handvoll Wörter für Sie – der schnellste erste Griff.",
	obGuideFive_title: "3 Wörter zum Start",
	obGuideFive_body: "Ein Klick auf den kleinen Pfeil und 3 zufällige Wörter landen in Ihrer Ablage.",
	obGuideFiveNext_title: "5 weitere nehmen",
	obGuideFiveNext_body: "Ein Klick auf den kleinen Pfeil und 5 zufällige Wörter landen in Ihrer Ablage.",
	obGuideDrill_title: "Jetzt abfragen",
	obGuideDrill_body: "Auf „Übung starten!“ klicken – eine kurze Übung auf Zeit festigt diese Wörter.",
	// {0} = die Sprache, in der DIESE Karte beantwortet wird (in einer Mix-Sitzung wechselt sie pro Karte).
	obGuideType_title: "Sie sind dran",
	obGuideType_body: "Hier die Übersetzung auf {0} eintippen und Enter drücken.",
	obGuideTypeWord_body: "Hier das Wort auf {0} eintippen und Enter drücken.",
	obTipSpacePron_title: "Wort anhören",
	obTipSpacePron_body: "Mit der Lautsprecher-Schaltfläche hören Sie die Aussprache des Wortes. Sie erscheint überall dort, wo ein Wort zu hören ist.",
	obTipThirsty_title: "Zeit zum Gießen",
	obTipThirsty_body: "Einige Ihrer Pflanzen sind durstig. Ein Klick auf den Chip legt genau diese Wörter in die Ablage – für eine schnelle Gießrunde.",
	obTipDirection_title: "Richtung wechseln",
	obTipDirection_body: "Antworten Sie in der Sprache, die Sie lernen, in Ihrer eigenen – oder mischen Sie beide in einer Lerneinheit. Die Lautsprecher-Schaltfläche fragt nach Gehör ab.",
	obTipMyGarden_title: "Hier wächst Ihr Garten",
	obTipMyGarden_body: "Jedes eingepflanzte Wort steht in Mein Garten – wachsend, durstig oder in voller Blüte.",
	obTipAddPill_title: "Mehr Wörter dazu",
	obTipAddPill_body: "„Hinzufügen“ verschiebt Wörter aus dieser Liste in Ihre Ablage. Eine Handvoll auf einmal wächst am besten.",
	obTipDictLookup_title: "Alles nachschlagen",
	obTipDictLookup_body: "Tippen Sie ein beliebiges Wort in der Sprache ein, die Sie lernen – mit Bedeutungen, Beispielen und Grammatik.",
	obTipGear_title: "Ganz nach Wunsch",
	obTipGear_body: "Tempo der Lerneinheit, Wiederholungen, Strenge – hier stellen Sie Ihr Training ein.",

	// ── Die Hilfe: das „?" in der Tab-Leiste (js/onboarding.js, Spez. §7) ──
	obHelpMenu_label: "Hilfe",
	obHelpMenuTip_label: "Tipp des Tages",
	obHelpMenuAllTips_label: "Alle Tipps",
	obHelpMenuReplay_label: "Geführte Tour",
	obHelpMenuWlTour_label: "Wortlisten-Tour",
	obHelpMenuWelcome_label: "Willkommensseite",

	// ── Tipp des Tages (js/tips.js, docs/project/tip-of-the-day.md) ──
	tipDay_title: "Tipp des Tages",
	tipsAll_title: "Alle Tipps",
	tipsClose_label: "Schließen",
	tipsOff_toast: "Tipps sind aus. Wieder einschalten unter Hilfe ▸ Alle Tipps.",
	tipsDaily_label: "Täglich einen Tipp zeigen",
	tipsToday_label: "Heute",
	tipTeaseSound_tooltip: "Diesen Satz anhören",

	// ── Lernmodus (der Lernen-Tab) ──
	learnEmpty_message: "Ihre Lernablage ist leer.",
	quickStart_line: "Holen Sie sich Wörter aus den Wortlisten links — oder greifen Sie hier direkt {0} zufällige Wörter heraus:",
	quickStart_count_tooltip: "Wie viele Wörter jeder Button hinzufügt",
	quickStart_exhausted_tooltip: "Hier ist schon alles gelernt — wählen Sie eigene Wörter aus den Wortlisten links",
	learnStartButton_label: "Lernen starten!",
	learnStartButton_tooltip: "Die neuen Wörter in Ruhe kennenlernen — kein Timer, kein Druck",
	learnClear_tooltip: "Lernablage leeren",
	learnRelearn_button: "Nochmal lernen",
	learnRelearn_tooltip: "Diese Wörter noch einmal abfragen — die Leiter beginnt von vorn, der Status „bereit“ bleibt",
	learnBackToTray_label: "← zurück zu den Wörtern",
	learnGuided_dots: "Üben · 6 Runden pro Wort",
	learnNew_badge: "neu",
	learnRow_progress_tooltip: "Schon begonnen — die Leiter läuft dort weiter, wo sie aufgehört hat",
	learnStudyTerm_tooltip: "Klicken für den vollständigen Wörterbucheintrag",
	learnMeet_reveal_label: "Übersetzung bekannt? Hier klicken oder Enter drücken, um sie zu zeigen",
	learnMeet_gotIt_label: "Verstanden →",
	learnMeet_fromVerb_label: "vom Verb",
	learnQ_meaning: "Was bedeutet es?",
	learnQ_pickWord: "Wählen Sie das Wort für:",
	learnQ_lookalike: "Genau hinsehen — welches Wort bedeutet:",
	learnQ_whoWhen: "Wer und wann?",
	learnQ_whoWhenHint: "das Pronomen fehlt absichtlich — die Endung sagt, wer",
	learnOpt_none: "Keines davon",
	learnNone_taught: "Richtig — das Wort war nicht dabei.",
	learnQ_phraseMeaning: "Was bedeutet {0} hier?",
	learnQ_pickPhrase: "Wählen Sie die Wendung für:",
	learnQ_pickGap: "Welches Wort passt in die Lücke?",
	learnQ_typeGapHint: "tippen Sie die ersten {0} Buchstaben des fehlenden Wortes — der Rest ergänzt sich",
	learnQ_typeFullGapHint: "tippen Sie nur das fehlende Wort — beim zweiten Fehler wird es gezeigt",
	learnQ_start: "Wie fängt es an?",
	learnQ_typeHint: "tippen Sie die ersten {0} Buchstaben — der Rest ergänzt sich",
	learnQ_letterHint: "Tipp: es beginnt mit {0}",
	learnQ_letterHintSubst: "Tipp: es beginnt mit {0} — „{1}“ funktioniert auch",
	learnQ_hearHint: "Tipp: hinhören — hier ist das Wort",
	learnQ_change: "Was ändert sich?",
	learnQ_changeHint: "tippen Sie den Teil, der sich in jeder Form ändert",
	learnQ_typeFull: "Jetzt das ganze Wort tippen",
	learnQ_typeFullHint: "aus dem Gedächtnis tippen — beim zweiten Fehler wird es gezeigt",
	learnQ_repeatWord: "Das Wort wiederholen",
	learnQ_hear: "Was war zu hören?",
	learnQ_pickHint: "Klicken Sie die richtige Karte an oder tippen Sie ihre Nummer",
	learnFeedback_correct: "Richtig!",
	learnFeedback_wrong: "Nicht ganz",
	learnFeedback_retry: "es folgt noch ein Versuch",
	learnMiss_settling: "Sitzt noch nicht ganz — gleich kommt es noch einmal.",
	learnMiss_continue: "Weiter →",
	learnSpace_tooltip: "Enter",
	learnReady_toast: "{0} ist bereit für die Abfrage",
	learnRecap_head: "{0} neue Wörter kennengelernt",
	learnRecap_met: "Wörter kennengelernt",
	learnRecap_ready: "bereit für die Abfrage",
	learnRecap_time: "Zeit",
	learnRecap_bridge: "Die Wörter warten in der Trainingsablage auf Sie — die Abfrage brennt sie dauerhaft ein.",
	learnRecap_drillNow: "Jetzt zum Training! →",
	learnRecap_back: "Zurück zum Lernen",
	learnNudge_message: "Ganz neue Wörter hier: {0} — erst unter „Lernen“ kennenlernen, dann fühlt sich die Abfrage völlig anders an.",
	learnNudge_action: "Erst kennenlernen",
	learnError_message: "Die Lerneinheit konnte nicht gestartet werden",

	proceed: "Fortfahren?",
	error: "Leider ist ein Fehler aufgetreten.\nBitte laden Sie die Seite neu",
	stopButton_tooltip: "Übung beenden und zurück zur Hauptseite",
	langTo_tooltip: "Sprache auswählen, die Sie lernen möchten",
	langFrom_tooltip: "Eigene Sprache oder eine Sprache auswählen, die Sie kennen",
	browserTitle_main: "{0} lernen — {1}",
	// Die beiden Flaggen-Felder — dieselben Worte wie die Zeilen daneben (main.label.*).
	enDialectUs_tooltip: "Amerikanisches Englisch — die Stimme, die Sie hören, die führende Lautschrift und der Akzent, an dem Ihre Aussprache gemessen wird",
	enDialectUk_tooltip: "Britisches Englisch — die Stimme, die Sie hören, die führende Lautschrift und der Akzent, an dem Ihre Aussprache gemessen wird",
	operationCannotComplete_message: "Vorgang kann nicht abgeschlossen werden",

	myList_create_tooltip: "Neue Wortliste anlegen",
	// ── Dictionary direction: the DE⇄EN toggle and the reverse (EN → DE) hit list ──
	// {0} = the language the typed word is expected to be in. Both directions are as-you-type: the
	// forward seek walks the German dictionary, the reverse one walks the tape of English keys
	// (design §9). Enter then focuses the one word, which is what "press Enter" used to mean here.
	lookupField_placeholder_forward: "Ein Wort auf {0} eintippen, um den Eintrag zu finden",
	lookupField_placeholder_reverse: "Ein Wort auf {0} eintippen, um die Wörter dafür zu finden",
	dictDir_forward_tooltip: "Ein Wort auf {0} nachschlagen — die Sprache, die Sie lernen (Alt+1)",
	dictDir_reverse_tooltip: "Ein Wort auf {0} nachschlagen — die passenden Wörter auf {1} finden (Alt+2)",
	reverse_intro_message: "Ein Wort auf {0} eintippen, um die passenden Wörter auf {1} zu sehen.",
	startButton_label: "Übung starten!",
	startButton_tooltip: "Klicken und Wörter lernen!",
	startButton_noWords_message: "Für die Übung waren keine Wörter ausgewählt.\nÖffnen Sie links eine Wortliste und nutzen Sie „Zum Training hinzufügen“.",
	connUpdating: "Parlevi startet neu. Bitte warten Sie eine Minute.",
	connLost: "Verbindung unterbrochen. Ihre Antworten sind gespeichert und werden übertragen, sobald sie wieder steht.",
	connNoNewExercise: "Parlevi startet neu. Bitte versuchen Sie es in einer Minute noch einmal.",
	revealWord_label: "Wort aufdecken",
	revealWord_tooltip: "Die Lösung für dieses Wort anzeigen",
	startButton_wordsInExercise: "Wörter für eine Übung:",
	// ── Übungsrichtung (Pfeil-Paar + Mix-Klammer + Lautsprecher im Start-Band) ──
	// Die Beschriftungen der Schalter entstehen aus den Sprachcodes ("EN → DE") und werden nicht
	// übersetzt; hier steht die Aufgabe. {0} = die Sprache, in der getippt wird.
	practiceDir_forward_tooltip: "Sie sehen die Bedeutung — tippen Sie das Wort auf {0}<p/>[beide Richtungen gedrückt = Mix]",
	practiceDir_reverse_tooltip: "Sie sehen das Wort — tippen Sie die Bedeutung auf {0}<p/>[beide Richtungen gedrückt = Mix]",
	practiceDir_mix_label: "Mix",
	practiceDir_mix_tooltip: "Beide Richtungen anklicken für eine gemischte Lerneinheit: Jedes Wort läuft in die Richtung, die es beim letzten Mal NICHT hatte<p/>(gleich viele Wörter — eine Karte pro Wort)",
	practiceDir_mixOff_tooltip: "Eine gemischte Lerneinheit braucht ganze Wörter (eine Karte pro Wort)",
	practiceDir_audio_tooltip: "Nach Gehör: das Wort hören statt die Bedeutung lesen<p/>Mit beiden Richtungen kombinierbar",
	practiceDir_locked_tooltip: "Die laufende Übung verwendet diese Richtung<p/>Zum Ändern die Übung stoppen",
	// Combined tray view only: distinct words vs total drillable senses ({0} = words, {1} = meanings).
	trayCount_wordsAndMeanings: "{0} Wörter · {1} Bedeutungen",
	number_of_words_remaining: "Anzahl der Wörter, die in der aktuellen Übung noch übrig sind",
	pauseButton_label: "Übung pausieren",
	pauseButton_tooltip: "Klicken, um das Lernen zu pausieren",
	continueButton_label: "Übung fortsetzen",
	continueButton_tooltip: "Klicken, um weiterzulernen",
	practiceAgainButton_label: "Nochmal üben!",
	practiceAgainButton_tooltip: "Dieselben Wörter noch einmal — jetzt sollten sie beim ersten Versuch sitzen",
	backToWordsButton_label: "Zur Wortauswahl",
	backToWordsButton_sub: "neues Set wählen",
	stopButton_label: "Übung stoppen",
	stopButton_sub: "(und zurück zur Startseite)",
	undo_label: "Rückgängig",
	// The message box's only button (js/msgbox.js). English-only on purpose: getRes falls back
	// to this file, and "OK" is the value in every one of the six locales (see i18n/global*.properties).
	msgOk_button: "OK",
	clearTray_button: "Leeren",
	clearTray_tooltip: "Die Trainingsablage leeren<p/>(Rückgängig stellt sie wieder her)",
	lastFinish_label: "Letzte Lerneinheit",
	lastFinish_tooltip: "Die zuletzt abgeschlossene Lerneinheit erneut anzeigen",
	trayCapped_message: "Eine Ablage fasst höchstens {0} Wörter — auf {2} von {1} gekürzt. Erst diese abfragen, dann den Rest ergänzen.",
	practiceEmpty_message: "Die Trainingsablage ist leer.",
	noWords_message: "Für diese Auswahl gibt es leider noch keine Wörter",
	dict_notReady_message: "Das Wörterbuch wird noch geladen — einen Moment…",
	// The flag + language code are prepended as markup, so these carry only the tail: "🇬🇧 EN" + …
	reverse_head_one: "Wort · 1 Treffer",
	reverse_head_many: "Wort · {0} Treffer",
	reverse_empty_message: "Kein Eintrag für „{0}“",
	reverse_fallback_message: "Kein Eintrag für „{0}“ — Ergebnisse für",
	reverse_seeAlso_label: "siehe auch:",
	reverse_phrases_label: "In Wendungen ({0})",
	chooseLangTo_label: "Wählen…",
	chooseLangTo_message: "Wählen Sie eine Sprache zum Lernen",
	noData_message: "Keine Daten vom Server erhalten",
	wlLabel: "Wortlisten",
	wlAddPick_label: "Hinzufügen zu…",
	wlAddPickNew_label: "Neue Liste…",
	richTerm_tooltip: "Klicken zum Einklappen — oder Esc bzw. die Zurück-Taste des Browsers drücken",
	revealTerm_tooltip: "Klicken öffnet den Wörterbucheintrag — Esc führt zurück zur Karte",
	richEmpty_none: "Dazu gibt es noch keinen Wörterbucheintrag.",
	richEmpty_failed: "Der Wörterbucheintrag konnte nicht geladen werden. Bitte die Verbindung prüfen und es erneut versuchen.",
	sound_tooltip: "Ton<p/>[Kurztaste: Leertaste]",

	pronMic_tooltip: "Aussprache üben<p/>Öffnet die Übungskarte — dort das Mikrofon gedrückt halten und sprechen",
	pronHold_tooltip: "Gedrückt halten und sprechen, zum Beenden loslassen",
	pronClose_tooltip: "Schließen",
	pronBest_label: "Bestwert",
	pronDialRecognition_label: "Verstanden",
	pronDialAccent_label: "Muttersprachlich",
	pronDialLegend_label: "Außenring = dieser Versuch · Mitte = Ihr Bestwert",
	pronDialRecLast_tooltip: "Dieser Versuch — wie viel davon ein Zuhörer verstehen würde: {0}",
	pronDialRecBest_tooltip: "Ihr Bestwert hier für Verständlichkeit: {0}",
	pronDialAccLast_tooltip: "Dieser Versuch — wie nah der Klang an einem Muttersprachler war: {0}",
	pronDialAccBest_tooltip: "Ihr Bestwert hier für muttersprachlichen Klang: {0}",
	pronDialNone_tooltip: "Hier noch nichts gesprochen",
	pronDialNoBest_tooltip: "Noch kein Bestwert vorhanden",
	pronDialPlay_hint: "klicken zum Anhören",
	pronNoRecording_message: "Keine Aufnahme — Ihre Stimme bleibt nur bis zum Schließen der Seite erhalten.",
	pronHint_hold: "zum Sprechen gedrückt halten — zum Beenden loslassen",
	pronHint_recording: "hört zu…",
	pronHint_scoring: "wird bewertet…",
	pronSoundedLike_tip: "klang wie /{0}/, wo /{1}/ hingehört",
	pronOmitted_tip: "dieses Wort war nicht zu hören",
	pronDiagHeard_text: "gehört: „{0}“",
	pronDiagEarHeard_text: "wer nicht wusste, was kommt, hat gehört: „{0}“",
	pronDiagPatient_text: "wer geduldig zuhört, versteht Sie hier; durchschnittliche Ohren tun sich schwer",
	pronDiagMissed_text: "nicht angekommen: {0}",
	pronDiagSilence_text: "in dieser Aufnahme war nichts zu hören",
	pronDiagSound_text: "schwächster Laut: /{0}/ in „{1}“",
	pronDiagSoundOnly_text: "schwächster Laut: /{0}/",
	pronDiagPart_text: "schwächste Stelle: „{0}“ in „{1}“",
	pronDiagPartOnly_text: "schwächste Stelle: „{0}“",
	pronDiagWord_text: "schwächstes Wort: „{0}“",
	pronExpPartial_text: "ein Teil wurde nicht gesprochen",
	pronExpPauses_text: "lange Pausen zwischen den Wörtern",
	pronExpFlat_text: "die Melodie blieb flach",
	pronSilent_message: "Diese Aufnahme ist stumm. Möglicherweise ist das Mikrofon stummgeschaltet oder aus.",
	pronNoMic_message: "Dieser Browser kann hier nicht auf ein Mikrofon zugreifen.",
	pronRefusalCap_message: "Das Trainingskontingent dieser Woche ist aufgebraucht. Es füllt sich eine Woche nach jedem Versuch wieder auf.",
	pronRefusalUnavailable_message: "Für diese Sprache gibt es keine Aussprachebewertung.",
	pronRefusalAudio_message: "In dieser Aufnahme war nichts zu hören.",
	pronRefusalNoWord_message: "Dieses Wort steht nicht mehr im Wörterbuch.",
	pronRefusalProvider_message: "Diesmal kam keine Bewertung zurück.",
	hist_wh_chart_spoken: "Aussprache",
	hist_wh_tip_chart_spoken: "Jedes Mal, wenn Sie dieses Wort laut gesagt haben. Ein Punkt pro Versuch, bewertet nach dem schwächsten Laut; die Linie ist Ihr bisher bestes Ergebnis.",
	wlLoad_error_message: "Ihre Wortlisten können nicht geladen werden",
	wlDelete_error_message: "Die Wortliste kann nicht gelöscht werden",
	wlRename_tooltip: "Diese Wortliste umbenennen",
	wlDelete_tooltip: "Diese Wortliste löschen",
	wlNoWords_message: "Keine Wörter ausgewählt",
	wlDeleteWords_tooltip: "Ausgewählte Wörter aus dieser Wortliste löschen",
	wlCopyWords_tooltip: "Ausgewählte Wörter in eine andere Wortliste kopieren",
	wlCopyNoLists_message: "Sie haben nur eine Wortliste — legen Sie zuerst eine weitere an und kopieren Sie die ausgewählten Wörter dann dorthin",
	wlDeleteWords_error_message: "Die Wörter können nicht aus der Wortliste gelöscht werden",
	wlCannotLoadWords_error_message: "Die Wörter der Wortliste können nicht geladen werden",
	wlCannotDeleteWord_error_message: "Das Wort kann nicht aus der Wortliste gelöscht werden",
	wlCopyWords_error_message: "Die Wörter können nicht in eine andere Wortliste kopiert werden",
	wlAddNoWordList_error_message: "Das Wort kann keiner Wortliste hinzugefügt werden — es ist keine Wortliste ausgewählt",
	wlAdd_error_message: "Das Wort kann keiner Wortliste hinzugefügt werden",
	wlVerbs_label: "Verbformen",
	wlVerbs_tooltip: "Unregelmäßige Verben, abgefragt als eine Karte pro Verb — alle Formen zusammen",
	wlConjugation_label: "Konjugation",
	wlConjugation_tooltip: "Verben, Form für Form abgefragt",
	wlVerbsNoForms_message: "Für dieses Verb konnten keine Formen vorbereitet werden",
	wlVerbsTruncated_message: "Die ersten {0} von {1} Verben wurden hinzugefügt — den Rest in einem weiteren Durchgang hinzufügen",
	wlVerbsExpand_error_message: "Die Verbformen können nicht vorbereitet werden",
	wlTypedPhrases_label: "Getippte Wendungen",
	wlTypedPhrases_tooltip: "Wendungen, die Sie getippt haben und die noch nicht in unserem Wörterbuch stehen — nur für Sie sichtbar. Neue landen automatisch hier",
	wlTypedRemove_tooltip: "Aus dieser Übersicht entfernen — Kopien in Ihren Listen bleiben",
	wlGarden_label: "Mein Garten",
	wlDefault_label: "Meine Liste",
	wlGarden_tooltip: "Jedes Wort, mit dem Sie wirklich gearbeitet haben — was gegossen werden muss, was begonnen ist und was wächst<p/>Klicken Sie auf die Blüte, um den ganzen Garten zu sehen",
	wlGardenNeedsWater_tooltip: "{0} Wörter sind überfällig zum Gießen<p/>Mein Garten öffnen, um sie zu sehen",
	wlGardenWatered_tooltip: "Gerade muss nichts gegossen werden — der ganze Garten ist auf dem neuesten Stand",
	wlGardenDifficult_label: "Schwierige Wörter",
	wlGardenWatering_label: "Muss gegossen werden",
	wlGardenProgress_label: "Wird gelernt",
	wlGardenReady_label: "Bereit fürs Training",
	wlGardenGrowing_label: "Wächst",
	wlGardenSetAside_label: "Zurückgestellt",
	wlGardenDifficult_tooltip: "Wörter, die Ihnen schwerfallen — an 3 verschiedenen Tagen üben, dann verschwindet das Wort aus dieser Liste",
	wlGardenWatering_tooltip: "Diese Wörter sind überfällig — jetzt gießen, damit sie weiterwachsen",
	wlGardenProgress_tooltip: "Diese Wörter haben Sie unter „Lernen“ begonnen, aber noch nicht abgeschlossen",
	wlGardenReady_tooltip: "Diese Wörter sind schon gelernt — jetzt brauchen sie Training",
	wlGardenGrowing_tooltip: "Diese Wörter sind eingepflanzt und noch nicht fällig — die Zahl zeigt die Tage bis zum nächsten Training",
	wlGardenSetAside_tooltip: "Zurückgestellte Wörter — sie ruhen hier und behalten alles Gelernte, bis Sie sie wieder wecken",
	wlGardenEmpty_message: "Noch nichts hier — lernen oder üben Sie ein Wort, und es erscheint in Ihrem Garten",
	wlGardenSecEmpty_tooltip: "In diesem Abschnitt ist gerade nichts",
	wlGardenContinueLearn_label: "Weiter in Lernen",
	wlGardenAll_disabled_tooltip: "Zu viele Wörter auf einmal (max. {0}) — nutzen Sie stattdessen „Zufällig“",
	wlGardenUseSections_note: "Jeder Abschnitt bedeutet etwas anderes — fügen Sie über die Kopfzeile des jeweiligen Abschnitts hinzu.",
	wlLevelA_label: "Grundstufe",
	wlLevelB_label: "Anfänger",
	wlLevelC_label: "Mittelstufe",
	wlLevelD_label: "Fortgeschritten",
	wlLevelE_label: "Experte",
	wlLevelA_tooltip: "Die 1.000 häufigsten Wörter · ≈ GER A1",
	wlLevelB_tooltip: "Wörter 1.001–4.000 · ≈ GER A2",
	wlLevelC_tooltip: "Wörter 4.001–12.000 · ≈ GER B1",
	wlLevelD_tooltip: "Wörter 12.001–24.000 · ≈ GER B2",
	wlLevelE_tooltip: "Jenseits der 24.000 häufigsten Wörter · ≈ GER C1–C2",
	// CEFR band slots. The codes are international, so every locale carries them unchanged —
	// genuine identity, not an untranslated placeholder (BundleParityTest guards the key set).
	wlLevelA1_label: "A1",
	wlLevelA2_label: "A2",
	wlLevelB1_label: "B1",
	wlLevelB2_label: "B2",
	wlLevelC1_label: "C1",
	wlLevelC2P_label: "C2+",
	wlLevelA1_tooltip: "GER-Niveau A1: vertraute Alltagsausdrücke und ganz einfache Sätze verstehen und verwenden",
	wlLevelA2_tooltip: "GER-Niveau A2: häufige Ausdrücke zu Themen des Alltags verstehen — Familie, Einkaufen, Arbeit, Umgebung",
	wlLevelB1_tooltip: "GER-Niveau B1: die Hauptpunkte klarer Standardsprache zu vertrauten Themen in Wort und Schrift verstehen",
	wlLevelB2_tooltip: "GER-Niveau B2: die Kernaussagen komplexer Texte verstehen und sich einigermaßen fließend verständigen",
	wlLevelC1_tooltip: "GER-Niveau C1: ein breites Spektrum anspruchsvoller, längerer Texte verstehen und Sprache flexibel einsetzen",
	wlLevelC2P_tooltip: "GER-Niveau C2: praktisch alles Gehörte und Gelesene mühelos verstehen — dazu seltenere und speziellere Wörter jenseits der GER-Stufen",
	// Plain-language band names — keys must exist in every locale; real translations exist in
	wlLevelA1_name: "Anfänger",
	wlLevelA2_name: "Grundstufe",
	wlLevelB1_name: "Mittelstufe",
	wlLevelB2_name: "Obere Mittelstufe",
	wlLevelC1_name: "Fortgeschritten",
	wlLevelC2P_name: "Meisterschaft",
	wlLevelSortAlpha_label: "Alphabetisch",
	wlLevelSortFreq_label: "Nach Häufigkeit",
	wlLevelSort_tooltip: "So ist diese Liste sortiert — zum Wechseln klicken",
	wlLevelCompactHint_tooltip: "<p>Doppelklick: die Niveau-Zeilen zu einem Streifen zusammenklappen.</p><p>Dort das 📖 doppelklicken, um wieder aufzuklappen.</p><p>Auch über: Kontomenü ▸ Einstellungen ▸ Wortlisten-Einstellungen.</p>",
	wlLevelExpandHint_tooltip: "<p>Doppelklick: aufklappen, eine Zeile pro Niveau.</p><p>Das 📖 einer Zeile doppelklicken, um wieder zusammenzuklappen.</p><p>Auf einen Buchstaben klicken, um diese Liste zu öffnen.</p><p>Auch über: Kontomenü ▸ Einstellungen ▸ Wortlisten-Einstellungen.</p>",
	wlLevelStripCount_tooltip: "Wörter im Wörterbuch für dieses Sprachpaar",
	wlVerbCompactHint_tooltip: "<p>Doppelklick: die Verb-Zeilen zu einem Streifen zusammenklappen.</p><p>Dort das 📝 doppelklicken, um wieder aufzuklappen.</p><p>Auch über: Kontomenü ▸ Einstellungen ▸ Wortlisten-Einstellungen.</p>",
	wlVerbExpandHint_tooltip: "<p>Doppelklick: aufklappen, eine Zeile pro Liste.</p><p>Das Symbol einer Zeile doppelklicken, um wieder zusammenzuklappen.</p><p>Auf ein Symbol klicken, um diese Liste zu öffnen.</p><p>Auch über: Kontomenü ▸ Einstellungen ▸ Wortlisten-Einstellungen.</p>",
	wlVerbStripCount_tooltip: "Verben auf beiden Listen für dieses Sprachpaar",
	wlTopics_label: "Themen",
	wlTopics_tooltip: "Das Wörterbuch nach Situationen — ein Thema wählen und seine Wortliste öffnen",
	wlTopicsPick_label: "Thema wählen",
	wlTopicsEmpty_message: "Noch keine Themen für dieses Sprachpaar",
	richTopicHint_tooltip: "(klicken, um die Wortliste zu diesem Thema zu öffnen)",
	topic_study_label: "Studium & Bildung",
	topic_travel_label: "Reisen & Verkehr",
	topic_food_label: "Essen & Trinken",
	topic_health_label: "Gesundheit & Körper",
	topic_sport_label: "Sport",
	topic_fashion_label: "Mode & Aussehen",
	topic_family_label: "Familie & Beziehungen",
	topic_work_label: "Arbeit & Beruf",
	topic_politics_label: "Politik & Gesellschaft",
	topic_home_label: "Haus & Haushalt",
	topic_money_label: "Einkaufen & Geld",
	topic_nature_label: "Natur, Wetter & Umwelt",
	topic_animals_label: "Tiere",
	topic_tech_label: "Technik & Internet",
	topic_media_label: "Medien & Kommunikation",
	topic_culture_label: "Kultur & Unterhaltung",
	topic_feelings_label: "Gefühle & Charakter",
	topic_law_label: "Recht & Kriminalität",
	wlAddPractice_button: "Zur Trainingsablage",
	wlAddLearn_button: "Zur Lernablage",
	wlAddMenuHeader_label: "Wörter in die Trainingsablage legen",
	wlAddMenuHeaderLearn_label: "Wörter in die Lernablage legen",
	wlMenuAll_label: "Alle",
	wlMenuMax_label: "Max. (erste {0})",
	wlMenuSelected_label: "Ausgewählte",
	wlMenuRandom_label: "Zufällig",
	wlMenuCountEdit_tooltip: "Anzahl der Wörter ändern",
	trayReplace_label: "In Ablage {0} ersetzen",
	trayAppend_label: "Zu Ablage {0} hinzufügen",
	trayReplace_math: "(−{0} : +{1})",
	trayAppend_math: "({0} + {1} → {2})",
	trayReplace_tooltip: "Die {0} bereits abgelegten Wörter verwerfen und stattdessen diese {1} abfragen",
	trayAppend_tooltip: "Die {0} bereits abgelegten Wörter behalten und diese {1} hinzufügen — insgesamt {2}",
	trayAppendUpTo_math: "({0} + bis zu {1})",
	trayAppendUpTo_tooltip: "Die {0} bereits abgelegten Wörter behalten und bis zu {1} weitere hinzufügen — schon abgelegte Wörter werden nicht doppelt aufgenommen"
		+ " — was schon im Fach liegt, kommt nicht doppelt hinein",
	trayNothingNew_tooltip: "Alle {0} liegen bereits in der Ablage — es gibt nichts hinzuzufügen",
	trayReplaceVerbs_tooltip: "Das Abgelegte verwerfen und stattdessen diese Verbformen abfragen (jedes Verb wird zu mehreren Karten, die Anzahl steht erst nach dem Aufschlüsseln fest)"
		+ " (jedes Verb wird zu mehreren Karten, die Anzahl steht erst nach dem Aufklappen fest)",
	trayAppendVerbs_tooltip: "Das Abgelegte behalten und diese Verbformen hinzufügen (jedes Verb wird zu mehreren Karten, die Anzahl steht erst nach dem Aufschlüsseln fest)"
		+ " (jedes Verb wird zu mehreren Karten, die Anzahl steht erst nach dem Aufklappen fest)",
	trayFull_tooltip: "Die Ablage ist mit {0} Wörtern voll — ersetzen oder zuerst etwas leeren",
	trayDest_practice: "Training",
	trayDest_learn: "Lernen",
	trayAddLearn_tooltip: "In die Lernablage legen",
	trayAddPractice_tooltip: "In die Trainingsablage legen",
	trayMoveLearn_tooltip: "In die Lernablage verschieben",
	trayMovePractice_tooltip: "In die Trainingsablage verschieben",
	trayAlreadyStaged_toast: "Schon in Ablage {0}",
	wlMove_label: "Verschieben nach…",
	wlCopy_label: "Kopieren nach…",
	wlSelected_label: "ausgewählt",
	wlEmptyList_message: "Hier sind noch keine Wörter — fügen Sie Wörter aus dem Wörterbuch oder aus anderen Wortlisten hinzu",
	wlNewListPlaceholder: "Name der neuen Liste…",
	wlFilterPlaceholder: "Wörter filtern…",
	wlxGlobalFilter_placeholder: "Wort in allen Listen finden…",
	wlxGlobalFilter_tooltip: "In allen Wortlisten suchen",
	wlNoMatch_message: "Keine Wörter passen zum Filter",
	wlCheckAll_tooltip: "Alle Wörter auswählen",
	wlGardenSecCheckAll_tooltip: "Alle Wörter in diesem Abschnitt auswählen",
	wlWordCount_tooltip: "Anzahl der Wörter in dieser Liste",
	wlRowPractice_tooltip: "Dieses Wort in die Trainingsablage legen",
	wlRowLearn_tooltip: "Dieses Wort in die Lernablage legen",
	wlRowMoveCopy_tooltip: "Dieses Wort in eine andere Wortliste verschieben oder kopieren",
	wlRowRemove_tooltip: "Dieses Wort aus der Liste entfernen",
	wlRowPark_tooltip: "Dieses Wort beiseitelegen — es kommt nicht mehr zum Üben dran und behält alles Gelernte, bis Sie es wieder aufwecken. Zu finden in Mein Garten, im Bereich „Beiseitegelegt“ ganz unten",
	wlRowWake_tooltip: "Dieses Wort aufwecken — es kehrt dort ins Training zurück, wo es aufgehört hat",
	wlRowUnmarkDifficult_tooltip: "Dieses Wort aus „Schwierige Wörter“ entfernen",
	wlRowDifficultMarks_tooltip: "An {0} von {1} Tagen geübt — an {1} verschiedenen Tagen abfragen, dann verlässt es diese Liste",
	wlRowDifficultHeld_tooltip: "An {0} Tagen geübt — die drei Tage sind erreicht, aber beim letzten Üben fiel dieses Wort erneut auf. Es verlässt die Liste nach dem ersten Üben, bei dem das nicht passiert.",
	wlRowDifficultStuck_tooltip: "An {0} Tagen geübt und fällt weiterhin auf — hier hilft es vielleicht mehr, das Wort noch einmal kennenzulernen, statt es weiter abzufragen. Legen Sie es beiseite oder machen Sie weiter: Es verlässt die Liste nach dem ersten Üben, bei dem es nicht auffällt.",
	wlRowParkFailed_error_message: "Dieses Wort lässt sich nicht beiseitelegen",
	trayParkNotStarted_message: "Dieses Wort wurde noch nicht geübt, es gibt also nichts beiseitezulegen — entfernen Sie es einfach aus der Ablage",
	trayRemove_tooltip: "Dieses Wort aus der Ablage entfernen",

	// ── Scroll pager: the scroll bars' aria-labels (js/scroll_pager.js — no tooltip: hovering
	//    one of these controls scrolls, so a popup would cover the rows it just set moving) ──
	scrollUp_tooltip: "Nach oben scrollen",
	scrollDown_tooltip: "Nach unten scrollen",

	knownToggle_tooltip: "Diese Bedeutung als bereits bekannt markieren — Übungen überspringen sie (erneut klicken zum Rückgängigmachen)",
	wlSort_tooltip: "Eigene Listen sortieren (die selbst erstellten Wortlisten)",
	wlSortNewest_label: "Neueste zuerst",
	wlSortOldest_label: "Älteste zuerst",
	wlSortAlpha_label: "Alphabetisch",
	wlSortSize_label: "Nach Größe",
	wlBasket_tooltip: "Kürzlich gelöschte Listen (Papierkorb)",
	wlBasketTitle_label: "Kürzlich gelöscht",
	wlBasketEmpty_button: "Alle endgültig löschen",
	wlBasketEmpty_message: "Der Papierkorb ist leer",
	wlRestore_button: "Wiederherstellen",
	wlRestore_tooltip: "Diese Liste wiederherstellen",
	wlDeleteForever_tooltip: "Endgültig löschen — nicht umkehrbar",
	tzDetected_text: "Erkannt",
	settingsTimeZone_tooltip: "Aus dem Browser erkannt — alles, was die App „heute“ nennt, richtet sich nach dieser Uhr.<p>Nur ändern, wenn sie falsch ist oder wenn Sie auf Reisen den heimischen Kalender behalten möchten.",
	settingsDayStart_tooltip: "Wann der Tag wechselt.<p>Bei der Voreinstellung 03:00 zählt eine Lerneinheit um 1 Uhr noch zum Vorabend — spätes Üben darf keine Serie kosten — und die Wiederholung nach dem Schlaf ist der nächste Tag. Für schlichte Mitternacht 00:00 einstellen.",
	signupOptional_tooltip: "Die Registrierung ist freiwillig.<p> Wenn Sie sich aber registrieren, bleiben Ihre persönlichen Wortlisten und Einstellungen erhalten und sind von jedem Computer aus verfügbar",
	tsVerbForms_hint: "unregelmäßiges Verb — {0} Formen",
	tsWhichVerb_question: "Welches Verb ist das?",
	tsWhichVerb_hint: "(jede Bedeutung des Verbs genügt)",
	tsListToSound: "Anhören — dann die Übersetzung auf {0} eintippen",
	tsWordNotRetrieved: "Wörter konnten nicht geladen werden",
	tsAnswerNotSet: "Antwort konnte nicht eingerichtet werden",
	tsYouDoneIt: "Gut gemacht!",
	tsCounterIsZero: "Zähler steht auf null",
	tsWrong: "Nicht ganz richtig",
	tsBestAttempt_label: "Ihr bester Versuch",
	//Wrong-answer tier phrases (wrong_feedback.js): tier 1 = way off ... tier 5 = almost right.
	tsWrongT1_1: "Ja, das ist ein schweres Wort — lassen Sie sich Zeit",
	tsWrongT1_2: "Ein harter Brocken — nur keine Eile",
	tsWrongT1_3: "Kniffliges Wort — dranbleiben",
	tsWrongT2_1: "Noch nicht — weitermachen",
	tsWrongT2_2: "Noch ein Versuch",
	tsWrongT2_3: "Das schaffen Sie",
	tsWrongT3_1: "Es wird wärmer",
	tsWrongT3_2: "Auf dem richtigen Weg",
	tsWrongT3_3: "Wird schon — dranbleiben",
	tsWrongT4_1: "Knapp daneben!",
	tsWrongT4_2: "Fast geschafft!",
	tsWrongT4_3: "Schon nah dran!",
	tsWrongT5_1: "Beinahe!",
	tsWrongT5_2: "So knapp!",
	tsWrongT5_3: "Ooh — um Haaresbreite!",
	tsSound_tooltip: "Anhören",
	tsReady_tip: "Den Cursor hier hineinsetzen und Enter drücken, um das nächste Wort der Übung zu erhalten",
	tsSelfKnow: "Ich verstehe",
	tsSelfDontKnow: "Ich verstehe nicht",
	tsSelfRight: "Ich lag richtig",
	tsSelfWrong: "Ich lag falsch",
	tsTypeTranslation_tip: "Hier die richtige Übersetzung auf {0} eintippen",
	tsTypeWord_tip: "Hier das richtige Wort auf {0} eintippen",
	tsDefinitionWasNotSet: "Die Definition des Wortes konnte nicht geladen werden",
	settings_tooltip: "Einstellungen",
	prefSpeed_tooltip: "Wie schnell der Countdown läuft, während Sie tippen. Längere Antworten bekommen mehr Zeit; 1 ist gemächlich, 10 ist ein Sprint.<p>Ein Wort, das danebengeht, bekommt beim nächsten Mal zusätzliche Zeit.",
	prefAdaptiveSpeed_tooltip: "Innerhalb einer Lerneinheit macht jede richtige Antwort auf ein Wort die nächste Anzeige etwas schneller — {0} % pro Schritt, bis zu {1} Schritte — ein Fehler nimmt einen Schritt zurück. Die erste Anzeige eines Wortes läuft immer im normalen Tempo.",
	prefStrictCaps_tooltip: "Groß- und Kleinschreibung zählt: Die Antwort muss genau der Schreibweise des Wortes entsprechen. Aus: Groß- und Kleinschreibung werden gleich behandelt.",
	prefDrillArticle_tooltip: "Ein Substantiv gilt nur mit Artikel als richtig: <i>der Kunde</i>, nicht bloß <i>Kunde</i>. Der Artikel gehört zum Wort, also gehört er zur Eingabe. Aus: Sie tippen nur das nackte Substantiv.",
	prefSelfCheck_tooltip: "Wenn das Wort gezeigt wird und die Bedeutung gefragt ist, antworten Sie im Kopf statt zu tippen — sagen, ob es sitzt, die Antwort ansehen, dann sagen, ob es stimmte. Aus: Sie tippen die Bedeutung.",
	prefGapPhrases_tooltip: "Ein Satz wird mit fehlendem Schlüsselwort gezeigt, und nur dieses Wort tippen Sie. Aus: Sie tippen den ganzen Satz.<p>Kurze Wendungen werden immer vollständig getippt — auf den genauen Wortlaut kommt es an.",
	prefStrictness_tooltip: "Wie viel Nachweis ein Wort braucht, um als bestanden zu gelten und im Garten zu wachsen. Links: aus dem Gedächtnis getippt, auch nach einem Blick auf die Antwort, oder nah genug — die Lerneinheiten bleiben kurz. Rechts: mehrfach exakt getippt, bevor der Countdown abläuft.<p>Die Zeile unter dem Regler erklärt die gewählte Einstellung.",
	prefVerbOnlyIrregular_tooltip: "Die Konjugationsliste enthält nur die unregelmäßigen Verben — die, deren Formen einzeln gelernt werden müssen. Aus: Sie listet alle Verben auf, auch die regelmäßigen.",
	prefVerbFullParadigm_tooltip: "Ein Verb aus der Konjugationsliste bringt seine ganze Tabelle mit — sechs Zeiten in sechs Personen, 36 Formen. Aus: Es kommen acht Kernformen: Präsens <i>ich, du, er, wir</i>; Perfekt <i>ich, er</i>; Präteritum <i>ich, du</i>.",
	prefVerbPronounPrefill_tooltip: "Auf einer Konjugationskarte steht das Pronomen schon vor dem Antwortfeld und Sie tippen nur die Verbform: <i>ich</i> ist vorgegeben, <i>fahre</i> wird getippt. Aus: Sie tippen das Pronomen mit.",
	prefTypedRowOff_tooltip: "In dieser Richtung nicht in Gebrauch: Hier antworten Sie mit der Bedeutung, nicht mit dem Wort, das Sie lernen.",
	prefSelfCheckOff_tooltip: "In dieser Richtung nicht in Gebrauch: Hier tippen Sie das Wort, das Sie lernen — da gibt es nichts selbst zu prüfen.",
	ai_unknownWord_error: "„{0}“ ist kein bekanntes Wort in {1}.",
	ai_disabled_error: "Die KI-Suche ist derzeit nicht verfügbar.",
	ai_signIn_error: "Melden Sie sich an, um heute neue Wörter nachzuschlagen.",
	audio_signIn_message: "Melden Sie sich an, um weiterhin neue Wörter zu hören.",
	phraseTooLong_message: "Das ist etwas zu lang für unser Wörterbuch — das Limit liegt bei 8 Wörtern und insgesamt 80 Zeichen.",
	rich_loading_message: "Wird nachgeschlagen…",
	rich_failed_message: "Nachschlagen fehlgeschlagen. Bitte erneut versuchen.",
	rich_enriching_message: "Der vollständige Eintrag wird vorbereitet…",
	rich_enrichFailed_message: "Für dieses Wort liegt vorerst nur die Übersetzung vor.",
	// Das Kollokationsband unter den A–Z-Zeilen (nur Vorwärtsrichtung).
	phraseBand_words_label: "In Wörtern",
	phraseBand_collocations_label: "In Kollokationen",
	phraseBand_examples_label: "In Beispielen",
	phraseBand_myPhrases_label: "Aus meinen Wendungen",
	phraseBand_noEntry_message: "Kein Wörterbucheintrag für „{0}“",
	phraseBand_stripOpen_tooltip: "Treffer anzeigen",
	phraseBand_stripClose_tooltip: "Diese Treffer ausblenden",
	phraseBand_pagerFirst_tooltip: "Zurück zur ersten Zeile",
	phraseBand_pagerPrev_tooltip: "{0} Zeilen zurück — halten zum Weiterblättern",
	phraseBand_pagerNext_tooltip: "{0} Zeilen vor — halten zum Weiterblättern",
	phraseBand_pagerLast_tooltip: "Zu den letzten Zeilen",
	phraseBand_pagerRow_tooltip: "Zeilen {0}–{1} von {2} — klicken zum Springen",
	// The wrong-toggle nudge: shown INSTEAD of generating an entry, when the typed word is not a
	// word of the language being learned but is a known meaning in the learner's own language.
	dict_wrongDirection_message: "„{0}“ sieht wie ein Wort in {1} aus.",
	dict_wrongDirection_switch: "{0} → {1} nachschlagen",
	dict_wrongDirection_anyway: "Nein — in {0} nachschlagen",
	dict_openMatch_prefix_message: "Meinten Sie „{0}“?",
	dict_openMatch_corrected_message: "Zeigt „{0}“.",
	dict_openMatch_lookup_link: "Stattdessen „{0}“ nachschlagen",
	reverse_phrases_shown: "Die ersten {0} von {1} werden angezeigt",
	stats_panel_title: "Mein Fortschritt",
	stats_scope_tooltip: "Alles, was Sie in {0} gelernt haben. Jede Lerneinheit zählt, in welcher Sprache die Hinweise auch verfasst waren.",
	stats_label_mastered: "beherrschte Wörter",
	stats_label_accuracy: "Trefferquote",
	stats_label_sessions: "Lerneinheiten",
	stats_label_studied: "gelernt",
	stats_streak: "{0} Tage in Folge",
	stats_best_streak: "Bestwert {0}",
	stats_today: "Heute: {0} Wörter · {1}",
	stats_coverage: "{0} der häufigsten {1} Wörter",
	stats_seen: "{0} Wörter gesehen",
	stats_learning: "{0} in Arbeit",
	exSummary_flawless: "fehlerfrei",
	exSummary_time: "Dauer der Lerneinheit",
	exSummary_speed: "typische Antwortzeit",
	exSummary_tricky: "Schwierige Wörter in dieser Lerneinheit — sollen sie zur Liste „Schwierige Wörter“ hinzugefügt werden?",
	exSummary_offerDifficult_tooltip: "Zu „Schwierige Wörter“ in Mein Garten hinzufügen",
	exSummary_difficultGraduated: "Nicht mehr schwierig! 🎉",
	exSummary_difficultProgress: "Gute Fortschritte bei den schwierigen Wörtern!",
	exSummary_difficultFiled: "Zu „Schwierige Wörter“ hinzugefügt:",
	exSummary_difficultFiled_shown: "— die Antwort wurde {0}-mal gezeigt",
	exSummary_difficultFiled_shownFew: "— die Antwort wurde {0}-mal gezeigt",
	phrasePick_tooltip: "In Wendungen üben — ein paar echte Sätze mit diesem Wort wählen",
	phrasePickTitle_label: "„{0}“ in Wendungen",
	phrasePickAdd_label: "Zum Üben hinzufügen",
	phrasePickDrop_tooltip: "Diesen Satz weglassen",
	phrasePickRestore_tooltip: "Diesen Satz zurückholen",
	phrasePickNone_message: "Für „{0}“ gibt es keine weiteren Wendungen — entweder sind noch keine gespeichert, oder Sie haben schon alle.",
	phrasePickAdded_message: "Zum Üben hinzugefügt.",
	exSummary_bridgeMastered: "insgesamt {0} Wörter beherrscht",
	exOutcome_recalledCold: "aus dem Stand gewusst",
	exOutcome_knownSlow: "gewusst — langsam abgerufen",
	exOutcome_knownArticle: "gewusst — Artikel wackelig, das Wort sitzt",
	exOutcome_warmUp: "brauchte einen Anlauf",
	exOutcome_relearned: "Antwort war nötig — kommt bald wieder",
	exOutcome_earlyPractice: "etwas gegossen — volles Wachstum, sobald es fällig ist",
	exOutcome_practiced: "geübt — Wachstum kommt, sobald es fällig ist",
	exSummary_grewToday: "Heute gewachsen ({0})",
	exSummary_stillGrowing: "Wächst noch ({0})",
	exOutcome_recalledCold_tooltip: "Erste Abfrage, richtige Antwort, sofort und ohne Hilfe.",
	exOutcome_knownSlow_tooltip: "Das Wort kam zurück, nur langsamer als sonst bei diesem Wort. Es zählt als gewusst.",
	exOutcome_knownArticle_tooltip: "Das Substantiv kam zurück, der Artikel nicht. Die Abfrage kam noch einmal, aber das Wort selbst zählt als erinnert.",
	exOutcome_warmUp_tooltip: "Beim ersten Versuch nicht ganz sauber – ein kleiner Patzer oder eine Antwort, die nach dem Moment kam, der noch als sofortiges Erinnern gilt. Es zählt trotzdem als erinnert, nicht als Fehler.",
	exOutcome_relearned_tooltip: "Die Antwort musste gezeigt werden, bevor dieses Wort wieder da war. Es steht nun früher wieder an als sonst.",
	exOutcome_earlyPractice_tooltip: "Geübt vor dem eigenen Gießtag. Das zählt, aber die Pflanze macht ihren Schritt an dem angezeigten Datum – früheres Üben zieht ihn nicht vor.",
	exOutcome_earlyPractice_tooltip_v2: "Geübt vor dem eigenen Gießtag. Das zählt, aber die nächste Wachstumsmarke der Pflanze ist ein fester Tag in ihrem eigenen Kalender, nicht das angezeigte Datum – eingelöst wird sie nur durch ein Bestehen an dieser Marke oder kurz davor.",
	exOutcome_practiced_tooltip: "Dieses Wort wurde heute schon geübt. Ein zweiter Durchgang am selben Tag zählt nicht als neue Wiederholung – der nächste Schritt kommt beim nächsten Gießen.",
	exSummary_grewToday_tooltip: "Diese Wörter sind heute eine Stufe aufgestiegen – der Pfeil zeigt den Schritt. Eine Pflanze wächst, wenn die Schätzung, wie lange das Wort noch erinnert würde, die nächste Marke überschreitet: 1, 3, 7, 14, 30, 60 oder 90 Tage.",
	exSummary_stillGrowing_tooltip: "Diese Wörter wurden gegossen, haben ihre Stufe aber behalten – das ist der Normalfall. Die Zahl vor jedem Wort ist das nächste Gießen, und es rückt meist weiter hinaus, auch wenn das Bild gleich bleibt. Die Pflanze verändert sich erst, wenn die Schätzung die nächste Marke überschreitet: 1, 3, 7, 14, 30, 60 oder 90 Tage.",
	// The heading those two share for the moment before the server has scored the session — see
	// renderWordSections. It names the only thing known then: which words were drilled.
	exSummary_sessionWords: "Wörter dieser Lerneinheit ({0})",
	exSummary_sessionWords_tooltip: "Alle Wörter, die in dieser Lerneinheit abgefragt wurden. Was gewachsen ist und was seine Stufe gehalten hat, erscheint einen Moment später, sobald die Lerneinheit ausgewertet ist.",
	garden_grow_title: "Heutiges Wachstum",
	// The same bed when nothing grew — it still holds every word the session drilled, so it is
	// named for what it honestly is rather than claiming growth that did not happen.
	garden_bed_session: "Wörter dieser Lerneinheit",
	garden_not_planted: "Noch nicht eingepflanzt",
	garden_grow_next: "nächstes Gießen in {0}",
	conj_tense_present: "Präsens",
	conj_tense_past: "Präteritum",
	conj_tense_perfect: "Perfekt",
	conj_tense_past_perfect: "Plusquamperfekt",
	conj_tense_future: "Futur",
	conj_tense_conditional: "Konjunktiv II (würde)",
	// Real German here, not English-verbatim (owner, 2026-08-28: each locale names the tenses the
	// way its own school tradition does): the face already IS the German term, so the tooltip adds
	// the school-book descriptive name.
	conj_tense_present_tip: "Präsens / Gegenwart",
	conj_tense_past_tip: "Präteritum / einfache Vergangenheit",
	conj_tense_perfect_tip: "Perfekt / vollendete Gegenwart",
	conj_tense_past_perfect_tip: "Plusquamperfekt / Vorvergangenheit",
	conj_tense_future_tip: "Futur / Zukunft",
	conj_tense_conditional_tip: "Konjunktiv II / Möglichkeitsform (würde)",
	// ── The Spanish conjugation panel (F2a, 2026-09-08) ──────────────────────────────────
	// The nine stored TAMs of register §2.5 plus the RENDERED negative imperative, which is
	// no + the present subjunctive and is never stored. The panel heads its columns with the
	// SPANISH name (Util.paradigmPack.ES in main.js), exactly as the German table heads its
	// own with Präsens; these are the learner-language names — the chip on a card, and the
	// header's hover tip.
	conj_tense_es_pres_ind: "Präsens",
	conj_tense_es_pret_ind: "Indefinido",
	conj_tense_es_imp_aff: "Imperativ",
	conj_tense_es_imp_neg: "Verneinter Imperativ",
	conj_tense_es_imperf_ind: "Imperfekt",
	conj_tense_es_fut_ind: "Futur",
	conj_tense_es_cond: "Konditional",
	conj_tense_es_pres_subj: "Subjuntivo Präsens",
	conj_tense_es_imperf_subj_ra: "Subjuntivo Vergangenheit (-ra)",
	conj_tense_es_imperf_subj_se: "Subjuntivo Vergangenheit (-se)",
	conj_tense_es_pres_ind_tip: "presente / Gegenwart",
	conj_tense_es_pret_ind_tip: "pretérito indefinido / abgeschlossene Vergangenheit",
	conj_tense_es_imp_aff_tip: "imperativo / Befehlsform",
	conj_tense_es_imp_neg_tip: "imperativo negativo / no + Subjuntivo Präsens",
	conj_tense_es_imperf_ind_tip: "pretérito imperfecto / andauernde oder gewohnheitsmäßige Vergangenheit",
	conj_tense_es_fut_ind_tip: "futuro simple / Zukunft",
	conj_tense_es_cond_tip: "condicional / Möglichkeitsform (würde)",
	conj_tense_es_pres_subj_tip: "presente de subjuntivo / Subjunktiv der Gegenwart",
	conj_tense_es_imperf_subj_ra_tip: "imperfecto de subjuntivo / Subjunktiv der Vergangenheit, Normalform",
	conj_tense_es_imperf_subj_se_tip: "imperfecto de subjuntivo / Subjunktiv der Vergangenheit, -se-Variante",
	// ── The Spanish FORM KINDS (F2b, 2026-09-08) ─────────────────────────────────────────
	// 77 kinds — 49 simple finite cells, 6 affirmative imperatives, 4 non-finite, 4 nominal,
	// 6 adjectival, 1 derived, 7 determiner/numeral — reached through PosLabel.CANON, exactly
	// like the German block above. ⭐ The _label is the SAME compact code in every bundle: a
	// finite cell names a tense AND a person, which no language abbreviates in five characters,
	// so the chip is Spanish-derived (pr2pl, ra3sg, ip1pl) and the _tooltip is the learner's.
	// Written by analytics/i18n/add_es_form_kind_keys.py — the tense halves are asserted equal
	// to the panel's own conj_tense_es_* values, so one screen never names a tense two ways.
	posVerbPresInd1Sg_label: "pr1sg",
	posVerbPresInd1Sg_tooltip: "Präsens, 1. Person Singular (yo)",
	posVerbPresInd2SgTu_label: "pr2sg",
	posVerbPresInd2SgTu_tooltip: "Präsens, 2. Person Singular (tú)",
	posVerbPresInd2SgVos_label: "prvos",
	posVerbPresInd2SgVos_tooltip: "Präsens, 2. Person Singular, Voseo (vos)",
	posVerbPresInd3Sg_label: "pr3sg",
	posVerbPresInd3Sg_tooltip: "Präsens, 3. Person Singular (él, ella, usted)",
	posVerbPresInd1Pl_label: "pr1pl",
	posVerbPresInd1Pl_tooltip: "Präsens, 1. Person Plural (nosotros)",
	posVerbPresInd2PlVosotros_label: "pr2pl",
	posVerbPresInd2PlVosotros_tooltip: "Präsens, 2. Person Plural, Spanien (vosotros)",
	posVerbPresInd3Pl_label: "pr3pl",
	posVerbPresInd3Pl_tooltip: "Präsens, 3. Person Plural (ellos, ellas, ustedes)",
	posVerbPretInd1Sg_label: "pt1sg",
	posVerbPretInd1Sg_tooltip: "Indefinido, 1. Person Singular (yo)",
	posVerbPretInd2SgTu_label: "pt2sg",
	posVerbPretInd2SgTu_tooltip: "Indefinido, 2. Person Singular (tú)",
	posVerbPretInd3Sg_label: "pt3sg",
	posVerbPretInd3Sg_tooltip: "Indefinido, 3. Person Singular (él, ella, usted)",
	posVerbPretInd1Pl_label: "pt1pl",
	posVerbPretInd1Pl_tooltip: "Indefinido, 1. Person Plural (nosotros)",
	posVerbPretInd2PlVosotros_label: "pt2pl",
	posVerbPretInd2PlVosotros_tooltip: "Indefinido, 2. Person Plural, Spanien (vosotros)",
	posVerbPretInd3Pl_label: "pt3pl",
	posVerbPretInd3Pl_tooltip: "Indefinido, 3. Person Plural (ellos, ellas, ustedes)",
	posVerbImperfInd1Sg_label: "im1sg",
	posVerbImperfInd1Sg_tooltip: "Imperfekt, 1. Person Singular (yo)",
	posVerbImperfInd2SgTu_label: "im2sg",
	posVerbImperfInd2SgTu_tooltip: "Imperfekt, 2. Person Singular (tú)",
	posVerbImperfInd3Sg_label: "im3sg",
	posVerbImperfInd3Sg_tooltip: "Imperfekt, 3. Person Singular (él, ella, usted)",
	posVerbImperfInd1Pl_label: "im1pl",
	posVerbImperfInd1Pl_tooltip: "Imperfekt, 1. Person Plural (nosotros)",
	posVerbImperfInd2PlVosotros_label: "im2pl",
	posVerbImperfInd2PlVosotros_tooltip: "Imperfekt, 2. Person Plural, Spanien (vosotros)",
	posVerbImperfInd3Pl_label: "im3pl",
	posVerbImperfInd3Pl_tooltip: "Imperfekt, 3. Person Plural (ellos, ellas, ustedes)",
	posVerbFutInd1Sg_label: "fu1sg",
	posVerbFutInd1Sg_tooltip: "Futur, 1. Person Singular (yo)",
	posVerbFutInd2SgTu_label: "fu2sg",
	posVerbFutInd2SgTu_tooltip: "Futur, 2. Person Singular (tú)",
	posVerbFutInd3Sg_label: "fu3sg",
	posVerbFutInd3Sg_tooltip: "Futur, 3. Person Singular (él, ella, usted)",
	posVerbFutInd1Pl_label: "fu1pl",
	posVerbFutInd1Pl_tooltip: "Futur, 1. Person Plural (nosotros)",
	posVerbFutInd2PlVosotros_label: "fu2pl",
	posVerbFutInd2PlVosotros_tooltip: "Futur, 2. Person Plural, Spanien (vosotros)",
	posVerbFutInd3Pl_label: "fu3pl",
	posVerbFutInd3Pl_tooltip: "Futur, 3. Person Plural (ellos, ellas, ustedes)",
	posVerbCond1Sg_label: "co1sg",
	posVerbCond1Sg_tooltip: "Konditional, 1. Person Singular (yo)",
	posVerbCond2SgTu_label: "co2sg",
	posVerbCond2SgTu_tooltip: "Konditional, 2. Person Singular (tú)",
	posVerbCond3Sg_label: "co3sg",
	posVerbCond3Sg_tooltip: "Konditional, 3. Person Singular (él, ella, usted)",
	posVerbCond1Pl_label: "co1pl",
	posVerbCond1Pl_tooltip: "Konditional, 1. Person Plural (nosotros)",
	posVerbCond2PlVosotros_label: "co2pl",
	posVerbCond2PlVosotros_tooltip: "Konditional, 2. Person Plural, Spanien (vosotros)",
	posVerbCond3Pl_label: "co3pl",
	posVerbCond3Pl_tooltip: "Konditional, 3. Person Plural (ellos, ellas, ustedes)",
	posVerbPresSubj1Sg_label: "sb1sg",
	posVerbPresSubj1Sg_tooltip: "Subjuntivo Präsens, 1. Person Singular (yo)",
	posVerbPresSubj2SgTu_label: "sb2sg",
	posVerbPresSubj2SgTu_tooltip: "Subjuntivo Präsens, 2. Person Singular (tú)",
	posVerbPresSubj3Sg_label: "sb3sg",
	posVerbPresSubj3Sg_tooltip: "Subjuntivo Präsens, 3. Person Singular (él, ella, usted)",
	posVerbPresSubj1Pl_label: "sb1pl",
	posVerbPresSubj1Pl_tooltip: "Subjuntivo Präsens, 1. Person Plural (nosotros)",
	posVerbPresSubj2PlVosotros_label: "sb2pl",
	posVerbPresSubj2PlVosotros_tooltip: "Subjuntivo Präsens, 2. Person Plural, Spanien (vosotros)",
	posVerbPresSubj3Pl_label: "sb3pl",
	posVerbPresSubj3Pl_tooltip: "Subjuntivo Präsens, 3. Person Plural (ellos, ellas, ustedes)",
	posVerbImperfSubjRa1Sg_label: "ra1sg",
	posVerbImperfSubjRa1Sg_tooltip: "Subjuntivo Vergangenheit (-ra), 1. Person Singular (yo)",
	posVerbImperfSubjRa2SgTu_label: "ra2sg",
	posVerbImperfSubjRa2SgTu_tooltip: "Subjuntivo Vergangenheit (-ra), 2. Person Singular (tú)",
	posVerbImperfSubjRa3Sg_label: "ra3sg",
	posVerbImperfSubjRa3Sg_tooltip: "Subjuntivo Vergangenheit (-ra), 3. Person Singular (él, ella, usted)",
	posVerbImperfSubjRa1Pl_label: "ra1pl",
	posVerbImperfSubjRa1Pl_tooltip: "Subjuntivo Vergangenheit (-ra), 1. Person Plural (nosotros)",
	posVerbImperfSubjRa2PlVosotros_label: "ra2pl",
	posVerbImperfSubjRa2PlVosotros_tooltip: "Subjuntivo Vergangenheit (-ra), 2. Person Plural, Spanien (vosotros)",
	posVerbImperfSubjRa3Pl_label: "ra3pl",
	posVerbImperfSubjRa3Pl_tooltip: "Subjuntivo Vergangenheit (-ra), 3. Person Plural (ellos, ellas, ustedes)",
	posVerbImperfSubjSe1Sg_label: "se1sg",
	posVerbImperfSubjSe1Sg_tooltip: "Subjuntivo Vergangenheit (-se), 1. Person Singular (yo)",
	posVerbImperfSubjSe2SgTu_label: "se2sg",
	posVerbImperfSubjSe2SgTu_tooltip: "Subjuntivo Vergangenheit (-se), 2. Person Singular (tú)",
	posVerbImperfSubjSe3Sg_label: "se3sg",
	posVerbImperfSubjSe3Sg_tooltip: "Subjuntivo Vergangenheit (-se), 3. Person Singular (él, ella, usted)",
	posVerbImperfSubjSe1Pl_label: "se1pl",
	posVerbImperfSubjSe1Pl_tooltip: "Subjuntivo Vergangenheit (-se), 1. Person Plural (nosotros)",
	posVerbImperfSubjSe2PlVosotros_label: "se2pl",
	posVerbImperfSubjSe2PlVosotros_tooltip: "Subjuntivo Vergangenheit (-se), 2. Person Plural, Spanien (vosotros)",
	posVerbImperfSubjSe3Pl_label: "se3pl",
	posVerbImperfSubjSe3Pl_tooltip: "Subjuntivo Vergangenheit (-se), 3. Person Plural (ellos, ellas, ustedes)",
	posImpAff2SgTu_label: "ip2sg",
	posImpAff2SgTu_tooltip: "Imperativ, 2. Person Singular (tú)",
	posImpAff2SgVos_label: "ipvos",
	posImpAff2SgVos_tooltip: "Imperativ, 2. Person Singular, Voseo (vos)",
	posImpAff3SgUsted_label: "ip3sg",
	posImpAff3SgUsted_tooltip: "Imperativ, 3. Person Singular (usted)",
	posImpAff1Pl_label: "ip1pl",
	posImpAff1Pl_tooltip: "Imperativ, 1. Person Plural (nosotros)",
	posImpAff2PlVosotros_label: "ip2pl",
	posImpAff2PlVosotros_tooltip: "Imperativ, 2. Person Plural, Spanien (vosotros)",
	posImpAff3PlUstedes_label: "ip3pl",
	posImpAff3PlUstedes_tooltip: "Imperativ, 3. Person Plural (ustedes)",
	posInfinitive_label: "inf",
	posInfinitive_tooltip: "Infinitiv",
	posGerund_label: "ger",
	posGerund_tooltip: "Gerundio (-ando / -iendo)",
	posParticiple_label: "part",
	posParticiple_tooltip: "Partizip Perfekt",
	posParticipleAlt_label: "part2",
	posParticipleAlt_tooltip: "Partizip Perfekt, zweite Form",
	posNounPlural_label: "pl",
	posNounPlural_tooltip: "Plural",
	posNounFeminineSg_label: "fsg",
	posNounFeminineSg_tooltip: "Femininum Singular, Substantiv",
	posNounFemininePl_label: "fpl",
	posNounFemininePl_tooltip: "Femininum Plural, Substantiv",
	posNounMascPlOfFemHead_label: "mpl",
	posNounMascPlOfFemHead_tooltip: "Maskulinum Plural zu einem femininen Stichwort",
	posAdjFemSg_label: "fsg",
	posAdjFemSg_tooltip: "Femininum Singular, Adjektiv",
	posAdjMascPl_label: "mpl",
	posAdjMascPl_tooltip: "Maskulinum Plural, Adjektiv",
	posAdjFemPl_label: "fpl",
	posAdjFemPl_tooltip: "Femininum Plural, Adjektiv",
	posAdjApocope_label: "apoc",
	posAdjApocope_tooltip: "vor einem Substantiv verkürzt (gran, buen)",
	posAdjSuperlativoAbsoluto_label: "sup",
	posAdjSuperlativoAbsoluto_tooltip: "absoluter Superlativ (-ísimo)",
	posAdjSuperlativoAbsolutoAlt_label: "sup2",
	posAdjSuperlativoAbsolutoAlt_tooltip: "absoluter Superlativ, zweite Form",
	posAdvMente_label: "adv",
	posAdvMente_tooltip: "Adverb auf -mente",
	posDetFemSg_label: "fsg",
	posDetFemSg_tooltip: "Femininum Singular, Determinativ",
	posDetMascPl_label: "mpl",
	posDetMascPl_tooltip: "Maskulinum Plural, Determinativ",
	posDetFemPl_label: "fpl",
	posDetFemPl_tooltip: "Femininum Plural, Determinativ",
	posDetNeuter_label: "neut",
	posDetNeuter_tooltip: "Neutrumform (lo, esto)",
	posDetApocope_label: "apoc",
	posDetApocope_tooltip: "vor einem Substantiv verkürzt",
	posNumFeminine_label: "fem",
	posNumFeminine_tooltip: "feminines Zahlwort (una, doscientas)",
	posNumApocope_label: "napo",
	posNumApocope_tooltip: "verkürztes Zahlwort (un, cien)",
	conj_person_firstSg: "1. Pers. Sg.",
	conj_person_secondSg: "2. Pers. Sg.",
	conj_person_thirdSg: "3. Pers. Sg.",
	conj_person_firstPl: "1. Pers. Pl.",
	conj_person_secondPl: "2. Pers. Pl.",
	conj_person_thirdPl: "3. Pers. Pl.",
	rich_perfect_tooltip: "Perfekt — wie dieses Verb sein Perfekt bildet: „hat …“ mit haben, „ist …“ mit sein",

	// ── Regel F7: die spanische Unregelmäßigkeitsklasse (F2b, Plan §4b Zeile 8) ────────────────
	// Je Klasse ein `_label` (der Wechsel, als Chip) und ein `_note` (die eine erklärende Zeile).
	// Das Beispielverb bleibt in jeder Sprache spanisch — es ist die gelernte Sprache.
	verb_class_tooltip: 'Unregelmäßigkeitsklasse — wie sich der Stamm dieses Verbs verändert. Die hervorgehobenen Präsensformen sind die veränderten; die übrigen folgen dem regelmäßigen Muster.',
	verbClassOrtografico_label: 'nur Schreibung',
	verbClassOrtografico_note: 'Die Schreibung ändert sich, damit der Laut gleich bleibt: coger → cojo.',
	verbClassEIe_label: 'e → ie',
	verbClassEIe_note: 'Der Stammvokal wird unter Betonung zum Diphthong: tener → tiene.',
	verbClassOUe_label: 'o → ue',
	verbClassOUe_note: 'Der Stammvokal wird unter Betonung zum Diphthong: llover → llueve.',
	verbClassEI_label: 'e → i',
	verbClassEI_note: 'Der Stammvokal schließt sich unter Betonung: pedir → pide.',
	verbClassEIeI_label: 'e → ie / i',
	verbClassEIeI_note: 'Diphthong unter Betonung, geschlossener Vokal ohne sie: sentir → siente, sintió.',
	verbClassOUeU_label: 'o → ue / u',
	verbClassOUeU_note: 'Diphthong unter Betonung, geschlossener Vokal ohne sie: dormir → duerme, durmió.',
	verbClassZco_label: '-zco',
	verbClassZco_note: 'Die 1. Person Singular endet auf -zco, und der ganze Konjunktiv folgt ihr: conocer → conozco.',
	verbClassIAcento_label: 'i → í',
	verbClassIAcento_note: 'Der schwache Vokal bekommt unter Betonung einen Akzent und bleibt eigene Silbe: ampliar → amplío.',
	verbClassUAcento_label: 'u → ú',
	verbClassUAcento_note: 'Der schwache Vokal bekommt unter Betonung einen Akzent und bleibt eigene Silbe: actuar → actúo.',
	verbClassEAcento_label: 'e → í',
	verbClassEAcento_note: 'Das e des Stamms wird unter Betonung í geschrieben: reír → río.',
	verbClassIIe_label: 'i → ie',
	verbClassIIe_note: 'Der Stammvokal wird unter Betonung zum Diphthong: adquirir → adquiere.',
	verbClassEYe_label: 'e → ye',
	verbClassEYe_note: 'Am Wortanfang wird der Diphthong ye geschrieben: errar → yerro.',
	verbClassUUe_label: 'u → ue',
	verbClassUUe_note: 'Der Stammvokal wird unter Betonung zum Diphthong: jugar → juega.',
	verbClassOHue_label: 'o → hue',
	verbClassOHue_note: 'Am Wortanfang wird der Diphthong hue geschrieben: oler → huele.',
	// ── SPANISH SENSE FIELDS (S4, 2026-09-08) ───────────────────────────────────────────
	// The copula and position splits, the sense's variety limits, and the shape of a
	// government frame. Region labels are looked up FROM THE CODE — never a prose prefix in
	// a gloss (register clause 14) and never a preposition in a template (a region reads as
	// `label: A, B`, because `en Espagne` / `au Mexique` cannot both come out of one hole).
	senseCopulaSer_label: 'mit ser',
	senseCopulaEstar_label: 'mit estar',
	senseCopulaAmbos_label: 'ser oder estar',
	sensePositionPrenominal_label: 'vor dem Substantiv',
	sensePositionPostnominal_label: 'nach dem Substantiv',
	sensePositionEither_label: 'beide Stellungen',
	senseRegionTypeOnlyIn_label: 'nur',
	senseRegionTypeNotIn_label: 'nicht gebräuchlich',
	senseRegionTypePreferredIn_label: 'bevorzugt',
	senseRegionES_label: 'Spanien',
	senseRegionMX_label: 'Mexiko',
	senseRegionAR_label: 'Argentinien',
	senseRegionUY_label: 'Uruguay',
	senseRegionPY_label: 'Paraguay',
	senseRegionCL_label: 'Chile',
	senseRegionPE_label: 'Peru',
	senseRegionBO_label: 'Bolivien',
	senseRegionEC_label: 'Ecuador',
	senseRegionCO_label: 'Kolumbien',
	senseRegionVE_label: 'Venezuela',
	senseRegionCR_label: 'Costa Rica',
	senseRegionGT_label: 'Guatemala',
	senseRegionHN_label: 'Honduras',
	senseRegionNI_label: 'Nicaragua',
	senseRegionPA_label: 'Panama',
	senseRegionSV_label: 'El Salvador',
	senseRegionCU_label: 'Kuba',
	senseRegionDO_label: 'Dominikanische Republik',
	senseRegionPR_label: 'Puerto Rico',
	senseRegionGQ_label: 'Äquatorialguinea',
	senseRegionUS_label: 'USA',
	senseRegionAM_label: 'Amerika',
	senseRegionRPL_label: 'Río de la Plata',
	senseRegionCAM_label: 'Mittelamerika',
	senseRegionAND_label: 'Andenraum',
	senseRegionCAR_label: 'Karibik',
	senseRegionCAN_label: 'Kanaren',
	senseConstructionPrepNp_label: '+ Nomen',
	senseConstructionPrepInf_label: '+ Infinitiv',
	senseConstructionPrepQueInd_label: '+ que + Indikativ',
	senseConstructionPrepQueSubj_label: '+ que + Subjunktiv',
	senseConstructionQueInd_label: 'que + Indikativ',
	senseConstructionQueSubj_label: 'que + Subjunktiv',
	senseConstructionInfDirecto_label: '+ blanker Infinitiv',
	senseConstructionDativoExperimentante_label: 'Dativ-Experiencer · me gusta el café',
	senseConstructionObjetoDativo_label: '+ le (Dativobjekt)',
	senseConstructionObjetoAcusativo_label: '+ direktes Objekt',
	senseConstructionSeImpersonal_label: 'unpersönliches se',
	senseMoodInd_label: '+ Indikativ',
	senseMoodSubj_label: '+ Subjunktiv',

	// ── Sitzungsverlauf (js/session_history.js) ──
	hist_title: "Lerneinheiten-Verlauf",
	hist_tooltip: "Alle mit diesem Sprachpaar abgeschlossenen Lerneinheiten",
	hist_back_label: "Zurück",
	hist_loading: "Wird geladen…",
	hist_failed: "Ihr Lerneinheiten-Verlauf konnte nicht geladen werden.",
	hist_empty: "Für dieses Sprachpaar gibt es noch keine abgeschlossenen Lerneinheiten.",
	hist_today: "Heute",
	hist_yesterday: "Gestern",
	hist_col_time: "Zeit",
	hist_col_mastered: "Beherrscht",
	hist_col_flawless: "Fehlerfrei",
	hist_col_accuracy: "Trefferquote",
	hist_col_shown: "Gezeigt",
	hist_col_wrong: "Falsch",
	hist_col_spent: "Dauer",
	hist_col_typical: "Typisch",
	hist_of: "von {0}",
	hist_of_label: "von",
	hist_stopped: "vorzeitig beendet",
	hist_dir_mix: "Gemischt",
	hist_dir_byEar: "Nach Gehör",
	hist_origin_random: "Zufällige Wörter",
	hist_origin_search: "Gesuchte Wörter",
	hist_origin_list: "Liste: {0}",
	hist_fact_when: "Wann",
	hist_fact_direction: "Richtung",
	hist_fact_source: "Wörter aus",
	hist_fact_set: "Wörter in der Auswahl",
	hist_fact_shown: "Wie oft gezeigt",
	hist_fact_correct: "Richtig",
	hist_fact_wrong: "Lösung aufgedeckt",
	hist_fact_replays: "Ton erneut abgespielt",
	hist_fact_outcome: "Ende",
	hist_outcome_completed: "Abgeschlossen",
	hist_outcome_stopped: "Vorzeitig beendet",
	hist_flawless_legend: "jedes Mal richtig — nie aufgedeckt, kein Fehlversuch",
	hist_tip_time: "Wann diese Lerneinheit begonnen hat.",
	hist_tip_mastered: "Wörter, die Sie abgeschlossen haben — für heute erledigt, aus den Wörtern, die diese Lerneinheit abfragen sollte.",
	hist_tip_flawless: "Wörter, die bei jeder Abfrage richtig waren: nie aufgedeckt und unterwegs nie eine falsche Antwort eingegeben.",
	hist_tip_accuracy: "Richtig ÷ gezeigt. Eine Abfrage endet entweder mit Ihrer richtigen Antwort oder damit, dass die Antwort aufgedeckt wird — das ist also der Anteil, den Sie selbst geschafft haben.",
	hist_tip_shown: "Wie oft Ihnen Wörter zur Beantwortung vorgelegt wurden, Wiederholungen mitgezählt.",
	hist_tip_right: "Wie viele dieser Abfragen Sie richtig beantwortet haben — egal, wie viele Versuche es innerhalb des Zeitlimits gebraucht hat.",
	hist_tip_wrong: "Wie viele Abfragen damit endeten, dass die Antwort aufgedeckt wurde: Die Zeit lief ab, oder Sie haben darum gebeten.",
	hist_tip_spent: "Vom ersten bis zum letzten Wort — die ganze Lerneinheit, Pausen eingeschlossen.",
	hist_tip_typical: "Wie lange eine richtige Antwort üblicherweise gedauert hat: der mittlere Wert über alle Wörter, damit eine lange Wendung das Bild nicht verzerrt.",
	hist_tip_direction: "In welche Richtung abgefragt wurde — zuerst die Sprache der Vorgabe, dann die der Antwort.",
	hist_tip_when: "Tag und Uhrzeit dieser Lerneinheit, von Anfang bis Ende.",
	hist_tip_source: "Woher die Wörter stammen.",
	hist_tip_set: "Wie viele Wörter für diese Lerneinheit in die Ablage gelegt wurden.",
	hist_tip_replays: "Wie oft Sie sich den Klang eines Wortes vor der Antwort noch einmal angehört haben. Eine Hilfe, um die Sie gebeten haben — kein Fehler.",
	hist_tip_outcome: "Ob die Lerneinheit bis zum Ende lief oder vorzeitig abgebrochen wurde.",
	hist_tip_word: "Das Wort, um das es in dieser Zeile geht. Klicken Sie die Zeile an, um den vollständigen Lernverlauf zu sehen.",
	hist_tip_meaning: "In welcher Bedeutung das Wort in dieser Lerneinheit abgefragt wurde — die Bedeutungen, nach denen die Karten tatsächlich gefragt haben.",
	hist_tip_wshown: "Wie oft Ihnen dieses Wort zur Beantwortung vorgelegt wurde.",
	hist_tip_wright: "Wie viele dieser Abfragen Sie richtig beantwortet haben, egal wie viele Versuche es innerhalb des Zeitlimits gebraucht hat.",
	hist_tip_wwrong: "Wie viele Abfragen damit endeten, dass die Antwort aufgedeckt wurde — die Zeit lief ab, oder Sie haben darum gebeten.",
	hist_tip_wtypical: "Ihre durchschnittliche Zeit bis zur richtigen Antwort bei diesem Wort. Abfragen ohne Antwort zählen nicht mit.",
	hist_tip_firstTry: "Gleich bei der ersten Abfrage richtig, ohne falsche Antwort dabei — ein Wort, das Sie schon kannten. Was bei den Wiederholungen passiert ist, ändert daran nichts.",
	hist_tip_wflawless: "Bei jeder Abfrage richtig, nie aufgedeckt und nie eine falsche Antwort eingegeben. Strenger als ein sauberer erster Versuch.",
	hist_firstTry_legend: "gleich beim ersten Zeigen richtig — kein Fehlversuch",
	hist_words_none: "Für diese Lerneinheit wurden keine Wörter aufgezeichnet.",
	hist_words_masteredHead: "Beherrscht ({0})",
	hist_words_alsoHead: "Ebenfalls abgefragt ({0})",
	hist_words_noMatch: "Kein Wort passt zu diesem Filter.",
	hist_wcol_word: "Wort",
	hist_wcol_meaning: "Bedeutung",
	hist_wcol_firstTry: "1. Versuch",
	hist_wcol_replays: "Audio",
	hist_wcol_right: "Richtig",
	hist_wcol_growth: "Wachstum",
	hist_wcol_next: "Fällig",
	hist_wcol_verdict: "Urteil",
	hist_tip_growth: "Ihre Pflanze für dieses Wort vor und nach der Lerneinheit. Ein Pfeil bedeutet, dass sie eine Stufe gewachsen ist; eine einzelne, blasse Pflanze bedeutet, dass sie auf ihrer Stufe geblieben ist — der normale Ausgang bei einem Wort, das vor seiner Fälligkeit geübt wurde.",
	hist_tip_grew: "Diese Lerneinheit hat die Pflanze eine Stufe wachsen lassen.",
	hist_tip_next: "Um wie viele Tage die App dieses Wort nach dieser Lerneinheit vorgemerkt hat — der Abstand, den sie bis zur nächsten Abfrage abwarten wollte. Länger heißt: Die Erinnerung hält.",
	hist_tip_next_drawn: "Diese Lerneinheit hat ein neues Datum für das Wort gezogen: {0}.",
	hist_tip_next_held: "Diese Lerneinheit hat das Datum nicht neu gezogen — eine frühe Übung oder eine Wiederholung am selben Tag lässt die bestehende Zusage unangetastet. Weiterhin fällig: {0}.",
	hist_tip_verdict: "Wie das Gedächtnismodell dieses Wort hier eingeschätzt hat, in seinen eigenen Worten. Das kann davon abweichen, wie sich die Abfrage angefühlt hat: Ein Wort, um das Sie gerungen haben, kann trotzdem als abgerufen zählen, und ein Wort, das richtig herauskam, kann trotzdem als langsam verbucht werden.",
	hist_days_short: "{0} T",
	hist_v_cold: "sofort abgerufen",
	hist_v_slow: "gewusst, langsam",
	hist_v_article: "gewusst, Artikel",
	hist_v_warmUp: "Aufwärmen",
	hist_v_relearned: "neu gelernt",
	hist_v_early: "früh",
	hist_v_sameDay: "gleicher Tag",
	hist_vtip_cold: "Das Wort kam sofort, im ersten Versuch, ohne Hilfe, und die App hat nichts Langsames daran gesehen. Die sauberste Art des Erinnerns — und die, die die Pflanze auf ihre nächste Stufe bringt.",
	hist_vtip_slow: "Sie sind allein darauf gekommen, ohne Hilfe, aber über der Zeit, die die App für dieses Wort einräumt — ein Budget, das sich aus Ihrem Tipptempo ergibt, nicht aus einer festen Uhr. Es zählt als gewusst, auch mit einem knappen Schreibfehler: Die Erinnerung ist da, sie ist nur noch nicht schnell.",
	hist_vtip_article: "Das Wort selbst kam zurück; der Artikel (der / die / das) nicht. Es zählt als gewusst — das Geschlecht ist der Teil, der noch fehlt, und die App fragt weiterhin nach beidem.",
	hist_vtip_warmUp: "Das Wort kam zurück, aber nicht sauber: ein knapper Schreibfehler, den die App durchgehen ließ, eine falsche Antwort, die Sie gleich korrigiert haben, oder eine so langsame, dass sie eher rekonstruiert als abgerufen wirkt. Die Abfrage kann Ihnen unterwegs trotzdem die Antwort gezeigt haben — hier geht es darum, was zurückkam, nicht darum, was die Abfrage getan hat. Es bleibt hinter einem sauberen Abruf zurück, zählt aber nicht als Fehler.",
	hist_vtip_relearned: "Das Wort wurde neu aufgebaut statt abgerufen: Es kam diesmal nicht von allein zurück, deshalb hat es Ihnen die Abfrage noch einmal gezeigt und Sie haben es erneut selbst gebildet. Dabei geht nichts verloren, und die Pflanze schrumpft nie – das Wort kommt einfach früher wieder an die Reihe, und es geht dort weiter, wo Sie stehen geblieben sind.",
	hist_vtip_early: "Dieses Wort wurde vor seinem Gießtermin geübt und dabei nicht vergessen. Training vor dem Termin zählt weniger als Training, wenn das Wort fällig ist – die Pflanze kann trotzdem eine Stufe aufsteigen, wenn die Erinnerung stark genug gewachsen ist, es braucht nur etwas mehr dafür.",
	hist_vtip_sameDay: "Dieses Wort kam innerhalb von etwa sechs Stunden nach der letzten gewerteten Wiederholung erneut an die Reihe – zu früh, um etwas Neues zu belegen. Deshalb wurde nichts gemessen und nichts ist gewachsen. Das Gedächtnis wächst in den Abständen zwischen den Übungen, nicht innerhalb einer einzelnen.",

	// ── Word statistics + one word's history ─────
	hist_ws_title: "Wortstatistik",
	hist_ws_tooltip: "Jedes Wort, das Sie mit diesem Sprachpaar geübt haben — Gesamtzahlen, Trends und die Historie jedes einzelnen Wortes",
	hist_ws_empty: "Für dieses Sprachpaar wurde noch kein Wort geübt.",
	hist_ws_count: "{0} Wörter · {1} beherrscht",
	hist_ws_col_sessions: "Lerneinheiten",
	hist_ws_col_trend: "Trend",
	hist_ws_col_mastered: "Beherrscht",
	hist_ws_mastered_legend: "in mindestens einer Lerneinheit beherrscht — diese ergeben zusammen die Zahl auf der Kachel",
	hist_ws_tip_word: "Das Wort, um das es in dieser Zeile geht. Für die vollständige Historie auf die Zeile klicken.",
	hist_ws_tip_sessions: "Wie viele abgeschlossene Lerneinheiten dieses Wort enthalten haben.",
	hist_ws_tip_shown: "Wie oft dieses Wort über alle Lerneinheiten hinweg zur Beantwortung vorgelegt wurde.",
	hist_ws_tip_right: "Abfragen, die richtig beantwortet wurden, über alle Lerneinheiten hinweg.",
	hist_ws_tip_wrong: "Abfragen, bei denen die Lösung aufgedeckt wurde — die Zeit lief ab oder sie wurde angefordert.",
	hist_ws_tip_accuracy: "Richtig ÷ gezeigt, über die gesamte Historie des Wortes.",
	hist_ws_tip_typical: "Ihre durchschnittliche Zeit bis zur richtigen Antwort bei diesem Wort, über alle Lerneinheiten hinweg.",
	hist_ws_tip_trend: "Antworttempo, spätere Lerneinheiten gegenüber früheren. ▼ bedeutet schneller. Braucht ein paar Lerneinheiten mit Zeitmessung, bevor es etwas aussagt.",
	hist_ws_tip_mastered: "In mindestens einer Lerneinheit fertig gelernt — so oft richtig beantwortet wie nötig. Diese Zeilen ergeben zusammen die Kachel „beherrschte Wörter“.",
	hist_ws_chart_speed: "Typische Antwortzeit je Lerneinheit",
	hist_ws_tip_chart_speed: "Jeder Punkt ist eine abgeschlossene Lerneinheit: ihre typische Zeit bis zur richtigen Antwort (Median pro Wort). Eine fallende Linie heißt, Sie werden schneller.",
	hist_ws_chart_mastered: "Beherrschte Wörter im Zeitverlauf",
	hist_ws_tip_chart_mastered: "Beherrschte Wörter, Lerneinheit für Lerneinheit aufaddiert.",
	hist_chart_few: "Noch zu wenig Training für eine Grafik.",
	hist_wh_tip_dictionary: "Den vollständigen Wörterbucheintrag zu diesem Wort öffnen.",
	hist_wh_none: "Dieses Wort wurde noch nicht geübt.",
	hist_wh_col_when: "Wann",
	hist_wh_tip_when: "Die Lerneinheit, die dieses Wort abgefragt hat — mit Tag und Startzeit. Auf die Zeile klicken, um sie zu öffnen.",
	hist_wh_firstSeen: "Zuerst geübt",
	hist_wh_tip_firstSeen: "Die erste Lerneinheit, in der dieses Wort vorkam.",
	hist_wh_lastSeen: "Zuletzt geübt",
	hist_wh_tip_lastSeen: "Die jüngste Lerneinheit, in der dieses Wort vorkam.",
	hist_wh_stage: "Wachstumsstufe",
	hist_wh_tip_stage: "Die Pflanze dieses Wortes in Ihrem Garten — sie wächst mit jeder bestandenen Wiederholung eine Stufe, bis zu 7.",
	hist_wh_due: "Nächstes Gießen",
	hist_wh_tip_due: "Wann die App dieses Wort wieder abfragen will. Die Abstände zwischen den Wiederholungen werden größer, je fester das Wort sitzt.",
	hist_wh_overdue: "überfällig",
	hist_wh_lapses: "Rückfälle",
	hist_wh_article: "Artikel",
	hist_wh_articleNone: "keiner eingegeben",
	hist_wh_tip_article: "Die Fälle, in denen das Wort da war, aber der falsche Artikel dazu. Das zählt als gewusst — üben muss man hier das Geschlecht, und genau dafür gibt es die Artikelabfrage.",
	hist_wh_tip_lapses: "Wiederholungen, bei denen das Wort entfallen war und neu gelernt werden musste.",
	hist_wh_chart_speed: "Antworttempo",
	hist_wh_tip_chart_speed: "Die Linie zeigt die typische Zeit bis zur richtigen Antwort je Lerneinheit. Die kleinen Punkte sind einzelne Abfragen. Ein ✗ am oberen Rand steht für eine Abfrage, bei der die Lösung aufgedeckt werden musste.",
	hist_wh_chart_gaps: "Tage zwischen den Wiederholungen",
	hist_wh_tip_chart_gaps: "Der Abstand vor jeder Wiederholung dieses Wortes. Wachsende Abstände zeigen ein festeres Gedächtnis: Die App wagt es, länger zu warten, und das Wort sitzt trotzdem. Der umrandete Balken ist die nächste geplante Wiederholung. Die gestrichelte Linie ist der Abstand, den die App bei der jeweiligen Lerneinheit vorgesehen hatte — liegt sie über dem Balken, waren Sie früher zurück als nötig.",
	hist_wh_scheduled: "geplant",
	hist_wh_chart_stage: "Pflanzenwachstum",
	hist_wh_tip_chart_stage: "Die Gartenstufe nach jeder gezählten Wiederholung. Grün: bestanden. Rot: Das Wort war weg und die Pflanze wurde zurückgesetzt.",
	hist_wh_chart_acc: "Trefferquote je Lerneinheit",
	hist_wh_tip_chart_acc: "Richtig ÷ gezeigt, in jeder Lerneinheit, die dieses Wort abgefragt hat.",
	hist_wh_revealed: "aufgedeckt",
	hist_wh_pass: "bestanden",
	hist_wh_fail: "vergessen",
	// ── The accuracy root + the time root ─────────────────
	hist_acc_title: "Genauigkeit",
	hist_acc_tooltip: "Wie sich Ihre Genauigkeit zusammensetzt und verändert – Lerneinheit für Lerneinheit, samt den Wörtern, die sie drücken",
	hist_acc_firstTry_lbl: "sofort gewusst",
	hist_acc_tip_accuracy: "Richtig ÷ gezeigt über alles, was mit diesem Sprachpaar geübt wurde – dieselbe Zahl, die auch die Kachel im Panel zeigt.",
	hist_acc_tip_firstTry: "Wörter, die schon beim allerersten Zeigen richtig beantwortet wurden, gemessen an allen Wörtern, die Ihnen Ihre Lerneinheiten vorgelegt haben. Der Abstand zur Genauigkeit ist das, was das Abfragen selbst beiträgt.",
	hist_acc_tip_chart_bySession: "Richtig ÷ gezeigt für jede abgeschlossene Lerneinheit, von der ältesten zur neuesten.",
	hist_acc_chart_firstTry: "Sofort gewusst je Lerneinheit",
	hist_acc_tip_chart_firstTry: "Der Anteil der Wörter einer Lerneinheit, die schon beim allerersten Zeigen richtig beantwortet wurden – Wiedererkennen, bevor das Abfragen zu helfen beginnt.",
	hist_acc_hard_head: "Schwierigste Wörter ({0})",
	hist_acc_hard_sub: "niedrigste Genauigkeit unter den Wörtern, die mindestens {0}-mal gezeigt wurden – für die ganze Historie auf ein Wort klicken",
	hist_acc_hard_none: "Kein Wort sticht heraus – nichts, was oft genug gezeigt wurde, hat eine niedrige Genauigkeit.",
	hist_time_title: "Lernzeit",
	hist_time_tooltip: "Wohin Ihre Lernzeit geflossen ist – Tag für Tag, insgesamt, und was eine Stunde Training bringt",
	hist_time_typical_lbl: "typische Lerneinheit",
	hist_time_days_lbl: "aktive Tage",
	hist_time_tip_total: "Die Länge aller abgeschlossenen Lerneinheiten zusammengerechnet. Pausen innerhalb einer Lerneinheit zählen mit, die Zeit zwischen den Lerneinheiten nicht.",
	hist_time_tip_sessions: "Abgeschlossene Lerneinheiten im Training für dieses Sprachpaar – dieselbe Zahl, die auch die Kachel im Panel zeigt.",
	hist_time_tip_typical: "Die mittlere Länge einer Lerneinheit: Die Hälfte war kürzer, die Hälfte länger – so kann ein einzelner Marathonabend das Bild nicht verzerren.",
	hist_time_tip_days: "Tage mit mindestens einer abgeschlossenen Lerneinheit. Ein Tag läuft bis 3:00 Uhr morgens, eine Lerneinheit um Mitternacht gehört also noch zum Abend davor.",
	hist_time_fact_longest: "Längste Lerneinheit",
	hist_time_tip_longest: "Die längste Sitzung am Stück und der Tag, an dem sie stattfand.",
	hist_time_fact_perDay: "Schnitt pro aktivem Tag",
	hist_time_tip_perDay: "Gesamte Lernzeit ÷ die Tage, an denen tatsächlich geübt wurde.",
	hist_time_fact_perWord: "Pro beherrschtem Wort",
	hist_time_tip_perWord: "Gesamte Lernzeit ÷ Anzahl der beherrschten Wörter – was ein dauerhaft sitzendes Wort kostet. Sinkt der Wert, läuft es gut.",
	hist_time_chart_byDay: "Trainingszeit pro Tag",
	hist_time_tip_chart_byDay: "Minuten abgeschlossenen Trainings an jedem Tag, an dem gelernt wurde – Lücken sind Tage ohne Training.",
	hist_time_chart_total: "Gesamtstunden im Verlauf",
	hist_time_tip_chart_total: "Lernzeit, Lerneinheit für Lerneinheit aufsummiert. Eine stetige Gewohnheit ergibt eine stetige Steigung.",

	// ── "How does my garden grow?" (docs/project/garden-growth-explainer.md) ──
	garden_guide_title: "Wie wächst mein Garten?",
	garden_guide_open_chip: "Wie wächst mein Garten?",
	garden_guide_ladder_note: "Gezählt ab dem ersten Training, mit jedem Gießen zur rechten Zeit.",
	garden_guide_ready_note: "Die erste Stufe, „Bereit“, ist ein Wort, das Sie schon gelernt, aber noch nicht geübt haben: Der Trieb zeigt sich bereits, doch es ist nichts geplant und nichts läuft, bis das Wort zum ersten Mal gegossen wird.",
	garden_guide_lead: "Bei guter Pflege — etwa ein halbes Jahr. Schneller als in rund vier Monaten geht es nicht.",
	garden_guide_lead_v2: "Bei guter Pflege — typischerweise etwa sieben bis neun Monate. Am schnellsten, wenn jedes Gießen genau pünktlich erfolgt, sind es rund sieben Monate.",
	garden_guide_how: "Ihre Pflanze wächst jedes Mal eine Stufe weiter, wenn Sie sie gießen, <em>sobald sie danach verlangt</em>, und das Wort noch wissen. Die Abstände zwischen dem Gießen beginnen winzig und werden größer, je tiefer das Wort Wurzeln schlägt: ein Tag, ein paar Tage, eine Woche, zwei Wochen, ein Monat, zwei Monate. Der leuchtende Strahlenkranz ist die letzte Stufe, und er bedeutet eines: Dieses Wort hat ein paar Monate ganz allein überstanden, und Sie wussten es noch. Diese Abstände summieren sich selbst bei einem Wort, das Ihnen mühelos zufällt, auf etwa vier Monate — und bei einem normalen auf rund sechs. Ein sperriges Wort braucht so lange, wie es braucht; die App arbeitet mit Ihnen weiter daran.",
	garden_guide_how_v2: "Ihre Pflanze wächst nur dann eine Stufe weiter, wenn ihre eigene Wachstumsmarke fällig wird — <em>nicht schon, weil gegossen wurde</em>. Das Gedächtnis festigt sich in etwa doppelt so großen Schritten: Wenn Sie ein Wort nach einer längeren Pause noch abrufen können, darf die nächste Pause gefahrlos etwa doppelt so lang sein. So klettern die Marken hinauf: ein Tag, drei Tage, eine Woche, zwei Wochen, ein Monat, zwei Monate, ein Vierteljahr. Ein Treffer kurz vor einer Marke zählt noch für sie — das Fenster ist knapp, aber es ist da. Der leuchtende Strahlenkranz ist die letzte Stufe, und er bedeutet eines: Dieses Wort hat ein ganzes Vierteljahr ganz allein überstanden, und Sie wussten es noch. Diese Marken summieren sich selbst bei einem Wort, das jede einzelne pünktlich schafft, auf etwa sieben Monate — und bei einem normalen auf sieben bis neun, denn eine verpasste Marke wartet einfach auf den nächsten guten Durchgang und kostet das Wort nichts. Ein sperriges Wort braucht so lange, wie es braucht; die App arbeitet mit Ihnen weiter daran.",
	garden_guide_twoThings: "Zwei Dinge, die man wissen sollte:",
	garden_guide_hurryHead: "Mehr Gießen beschleunigt nichts.",
	garden_guide_hurryBody: "Ein Wort heute zehn Mal zusätzlich zu üben lässt nichts wachsen — die App weiß längst, dass Sie es <em>heute</em> wissen. Sie will sehen, ob Sie es nächste Woche und nächsten Monat noch wissen. Das Gedächtnis wächst in den Pausen, und die Pflanze zeigt das ganz ehrlich.",
	garden_guide_forgetHead: "Vergessen ist kein Beinbruch.",
	garden_guide_forgetBody: "Entgleitet Ihnen ein Wort, schrumpft die Pflanze nie — sie wird nur durstig 💧, kommt früher wieder, und es geht dort weiter, wo Sie waren.",
	garden_guide_closing: "Also: einpflanzen, gießen, wenn die Pflanze danach verlangt — und mit dem Strahlenkranz in etwa einer bis zwei Jahreszeiten rechnen. Beschleunigen lässt sich das nicht — und genau deshalb bedeutet es etwas. Eine leuchtende Blüte ist kein Abzeichen fürs Knöpfedrücken; sie ist die App, die Ihnen sagt: <em>Dieses Wort gehört jetzt Ihnen, für immer.</em>",
	garden_guide_closing_v2: "Also: einpflanzen, gießen, wenn die Pflanze danach verlangt — und mit dem Strahlenkranz in zwei bis drei Jahreszeiten rechnen. Beschleunigen lässt sich das nicht — und genau deshalb bedeutet es etwas. Eine leuchtende Blüte ist kein Abzeichen fürs Knöpfedrücken; sie ist die App, die Ihnen sagt: <em>Dieses Wort gehört jetzt Ihnen, für immer.</em>",
	garden_firstplant_card: "Ihr erstes Wort ist gekeimt 🌱 — sehen Sie zu, wie es zur leuchtenden Blüte heranwächst.",
	// The day badge's watering tooltip + the plant's click hint.
	garden_water_next: "Dieses Wort in {0} wieder gießen — genau das sagt die Zahl. Früher zu üben lässt die Pflanze nicht schneller wachsen.",
	garden_water_today: "Heute fällig — dieses Wort kann gegossen werden. Der Punkt bleibt leer, bis es einen ganzen Tag überfällig ist.",
	garden_water_overdue: "Seit {0} überfällig — dieses Wort ist durstig. Nichts geht verloren: Die Pflanze schrumpft nie, sie kommt nur früher wieder dran.",
	// P6 garden growth v2 surfaces (buckets, sprout, soft next-mark words, decision moment)
	garden_sprout_stage_name: "Keimling",

	// Die acht Stufen der Wachstumsleiter (garden.js). Begriffe wie im übrigen Bundle:
	// „beherrscht" wie in hist_ws_count, „Keimling" als Stufe 0 darüber.
	garden_ready_stage_name: "Bereit",
	garden_stage1_name: "Einmal gesehen",
	garden_stage2_name: "Wiedererkannt",
	garden_stage3_name: "Erinnert",
	garden_stage4_name: "Schlägt Wurzeln",
	garden_stage5_name: "Verwurzelt",
	garden_stage6_name: "Vertraut",
	garden_stage7_name: "Beherrscht",
	// The next GROWTH mark, in soft words, appended to the watering badge's tooltip. Five spans
	// since 2026-08-25 (was three): everything past a fortnight used to collapse into "further
	// out", so 30 days and 90 days read the same and "not due to grow yet" looked like a repeated
	// non-answer. Words, never digits — that is what keeps this inside R38's "soft words only".
	// garden.js's SOFT_MARK_SPANS holds the cutoffs (3 / 14 / 45 / 75 days).
	garden_nextMark_fewDays: "Nächster Blick aufs Wachstum: in ein paar Tagen.",
	garden_nextMark_twoWeeks: "Nächster Blick aufs Wachstum: in etwa zwei Wochen.",
	garden_nextMark_month: "Nächster Blick aufs Wachstum: in etwa einem Monat.",
	garden_nextMark_twoMonths: "Nächster Blick aufs Wachstum: in etwa zwei Monaten.",
	garden_nextMark_fewMonths: "Nächster Blick aufs Wachstum: in ein paar Monaten.",
	// ── the finish screen's three word groups (docs/project/finish-screen-classification.md) ──────
	// ONE axis: the verdict at the user's own strictness notch. The four R13 buckets are still what
	// the server sends and still decide the split INSIDE "Recalled"; they stopped being group names
	// because "Will grow soon" / "Needs sooner watering" describe what the app did, which the user
	// can check and disagree with, while the group is a claim about what they remembered.
	//
	// {1} in the two verdict heads is the linked word — main.js's exStrictnessHead splits the
	// formatted string there and drops an <a> in. Keep {1} in any translation, and inflect
	// exGroup_strictnessWord to match the case the sentence puts it in.
	exGroup_firstWatering: "Erstes Gießen ({0})",
	// The one celebratory line on this card (owner, 2026-08-25). Deliberately says nothing about
	// pass or fail: a first practice is a first meeting, so there was nothing to recall yet.
	exGroup_firstWatering_note: "Glückwunsch — das erste Gießen! Diese Triebe haben Wurzeln geschlagen und beginnen zu wachsen.",
	exGroup_firstWatering_tooltip: "Beim ersten Üben eines Wortes wird aus seinem Trieb eine richtige Pflanze: Sie bekommt einen Platz im Gießplan und arbeitet auf ihre erste Wachstumsmarke hin. Hier wird nichts bewertet — das erste Üben ist ein Kennenlernen, keine Gedächtnisprüfung.",
	exGroup_recalled: "Gewusst — bei Ihrem {1} ({0})",
	exGroup_recalled_tooltip: "Diese Wörter haben Sie so wiedergegeben, wie Sie es selbst mit dem Regler für den Strengegrad festgelegt haben. Klicken Sie auf die Wörter, um diese Schwelle anzusehen oder zu ändern — sie allein entscheidet, in welche Gruppe ein Wort fällt.",
	exGroup_notDueYet: "Die Blüte ist noch nicht fällig ({0})",
	exGroup_notDueYet_tooltip: "Diese Wörter kamen zurück, und ihre Blüte hat einfach noch keine fällige Wachstumsmarke. Der Normalfall, kein Rückstand: Eine Pflanze wächst, wenn sie ihre eigene nächste Marke erreicht — nach 1, 3, 7, 14, 30, 60 oder 90 Tagen — nie, weil eine Antwort mehr richtig war.",
	exGroup_notRecalled: "Nicht gewusst — bei Ihrem {1} ({0})",
	exGroup_notRecalled_tooltip: "Diese Wörter kamen nicht so zurück, wie Sie es selbst mit dem Regler für den Strengegrad festgelegt haben. Nichts geht verloren, und keine Pflanze schrumpft je — sie kommen einfach früher wieder. Klicken Sie auf die Wörter, um diese Schwelle anzusehen oder zu ändern.",
	exGroup_strictnessWord: "Strengegrad",
	exBucket_grew: "Heute gewachsen ({0})",
	exBucket_grew_tooltip: "Diese Wörter haben heute ihre nächste Wachstumsmarke erreicht — ein fester Tag in ihrem eigenen Kalender, verdient durch echtes Üben an oder nach diesem Tag, nie durch die Schätzung eines Modells.",
	exBucket_multiStage: "ist mehrere Stufen auf einmal gewachsen",
	decisionMoment_pileUp: "Diese Woche wird im Vergleich zu Ihrem bisherigen Tempo viel fällig. Sie könnten den Lerneinheiten etwas mehr Zeit geben, den Strengegrad eine Stufe lockern oder langsamer neue Wörter aufnehmen.",
	decisionMoment_headroom: "Ihr Trainingspensum ist im Vergleich zu Ihrem bisherigen Tempo leicht — da ist Luft, um mehr Wörter aufzunehmen, den Strengegrad eine Stufe anzuziehen oder einfach so weiterzumachen wie bisher.",
	garden_day_one: "Tag",
	garden_day_few: "Tage",
	garden_day_many: "Tage",
	garden_stats_click_hint: "Klicken für die Statistik zu diesem Wort",
	garden_forms_growing: "{0} Formen wachsen",
	garden_grow_from: "vorherige Stufe: {0}",
	garden_grow_open: "Klicken, um den ganzen Garten zu sehen",
	garden_vista_title: "Mein Garten",
	garden_vista_count: "{0} Wörter eingepflanzt",
	garden_vista_empty: "Noch nichts eingepflanzt — üben Sie ein Wort, und der erste Trieb erscheint hier.",
	garden_sr_edu: "💡 Zweimal täglich gießen beschleunigt das Wachstum nicht — Pflanzen brauchen Zeit zwischen zwei Güssen.",
	garden_thirsty_chip: "{0} durstig",
	garden_thirsty_tooltip: "Zum Gießen fällige Wörter<p/>Klicken, um sie in die Trainingsablage zu legen",
	// Shown on EVERY press of the chip, not only when something new landed: a press that added
	// nothing (they were all staged already) used to answer with silence and read as a broken
	// button. The sentence is true either way, and it answers the question the press was asking.
	garden_thirstyStaged_toast: "Alle durstigen Pflanzen liegen in der Ablage, bereit zum Gießen!",
	garden_open_btn: "Mein Garten",
	garden_open_tooltip: "Ihr ganzer Wortgarten — jedes eingepflanzte Wort auf seiner aktuellen Stufe",
	garden_vista_click_hint: "Klicken für den vollständigen Eintrag",

	// ── Feedback: der 💬 Dialog (js/feedback.js). EN, bis ein DE-Durchgang läuft. ──
	feedback_menu: "Feedback senden",
	feedback_title: "Feedback senden",
	feedback_type_problem: "Problem",
	feedback_type_dislike: "Gefällt mir nicht",
	feedback_type_like: "Gefällt mir",
	feedback_type_idea: "Vorschlag",
	feedback_type_question: "Frage",
	feedback_ph_start: "Oben auswählen, dann Nachricht schreiben",
	feedback_ph_problem: "Was ist schiefgelaufen?",
	feedback_ph_dislike: "Was gefällt Ihnen nicht?",
	feedback_ph_like: "Was gefällt Ihnen?",
	feedback_ph_idea: "Was könnte besser laufen?",
	feedback_ph_question: "Was möchten Sie wissen?",
	feedback_email_label: "E-Mail für Antwort (optional)",
	feedback_send: "Senden",
	feedback_cancel: "Abbrechen",
	feedback_thanks: "Vielen Dank! Wir lesen jede Nachricht.",

	// ── Owner-only word-decision audit table (session-word-audit.md) ──
	audit_title: "Wort-Audit",
	audit_none: "Für diese Lerneinheit wurde kein Audit erfasst.",
	audit_empty: "Diese Lerneinheit enthält keine auditierten Wörter.",
	audit_finish_tooltip: "Nur für Owner: die volle Entscheidungslogik zu jedem Wort dieser Lerneinheit",
	audit_history_chip: "Audit",
	audit_y_pass: "bestanden",
	audit_y_fail: "gescheitert",
	audit_y_void: "ungültig",
	audit_col_seq: "Nr.",
	audit_col_outcome: "Ergebnis",
	audit_col_tier: "Ebene",
	audit_col_latency: "Latenz",
	audit_col_shownTs: "Gezeigt um",
	audit_outcome_PASS: "bestanden",
	audit_outcome_FAIL: "gescheitert",
	audit_outcome_TIMEOUT: "Timeout",
	audit_outcome_MEET: "kennengelernt",
	audit_outcome_REVEAL: "aufgedeckt",
	audit_acol_attempt: "#",
	audit_acol_submitted: "Eingabe",
	audit_acol_correct: "Richtig",
	audit_acol_similarity: "Sim",
	audit_acol_errorClass: "Fehler",
	audit_acol_firstKeyMs: "1. Taste",
	audit_acol_completionMs: "Abschluss",
	audit_acol_allottedMs: "Limit",
	audit_acol_keystrokes: "Tasten",
	audit_acol_backspaces: "Rückt.",
	audit_yes: "Ja",
	audit_no: "Nein",
	audit_censored: "zensiert",
	audit_group_label: "Label",
	audit_group_m5: "M5",
	audit_group_garden: "Garten",
	audit_f_y: "y",
	audit_f_labelFlags: "Flags",
	audit_f_nPres: "n Präsentationen",
	audit_f_nMin: "n min",
	audit_f_criterionMet: "Kriterium erfüllt",
	audit_f_g: "g",
	audit_f_gFinal: "g final",
	audit_f_epsilon: "Epsilon",
	audit_f_lStarMs: "L*",
	audit_f_sBefore: "S vorher",
	audit_f_sAfter: "S nachher",
	audit_f_dAfter: "D nachher",
	audit_f_rHat: "R̂",
	audit_f_rStar: "R*",
	audit_f_intervalDays: "ΔTage",
	audit_f_floored: "Auf Minimum gesetzt",
	audit_f_dueTs: "Fällig",
	audit_f_algoVersion: "Algo-Version",
	audit_f_decisionType: "Entscheidungstyp",
	audit_f_stageBefore: "Stufe vorher",
	audit_f_stageAfter: "Stufe nachher",
	audit_f_result: "Ergebnis",
	audit_f_wasDue: "War fällig",
	audit_f_promoted: "Aufgestiegen",
	audit_f_planted: "Eingepflanzt",
	audit_f_grew: "Gewachsen",
	audit_f_lapses: "Aussetzer",
	// The P4 shadow-verdict strip -- owner-only surface.
	audit_group_verdict: "Urteil",
	audit_group_flower: "Blüte",
	audit_decision_head: "Entscheidung",
	audit_f_notch: "Kerbe",
	audit_f_band: "Band ≥",
	audit_f_showingsPlanned: "geplant",
	audit_f_bucket: "Fach",
	audit_f_nextMarkDays: "Nächste Marke (d)",
	audit_f_otherEngine: "Andere Engine sagte",
	audit_f_dueModel: "Fällig (Modell)",
	audit_f_nextShown: "Nächste Anzeige",
	audit_more_showings: "weitere Anzeigen nach der Versiegelung — nur als Nachweis",
	audit_more_details: "Alles Weitere (vollständige Anzeigen, alle Kerben, Blöcke im Wortlaut)",
	audit_lcol_showings: "Anzeigen",
	audit_lcol_peeks: "Blicke",
	audit_lcol_time: "Zeit",
	audit_lcol_close: "Nähe",
	audit_lcol_rstar: "r*",
	audit_lcol_flower: "Blüte",
	audit_lcol_why: "Warum",
	audit_words_count: "{0} Wörter",
	audit_grid_mixed: " · gemischte Kerben",
	audit_gate_perfect: "perfekt",
	audit_gate_off_peeks: "Ein Blick-Budget gibt es nur in Familie A (Kerben 1–3).",
	audit_gate_off_time: "Nur zur Beobachtung — die Zusammenstellung liest den Zeitregler nie. Ist-Wert = Kerbengewicht × Latenz/Vorgabe ({0}) der entscheidenden Anzeige.",
	audit_gate_off_rstar: "M5 wurde gegen r* {0} geplant; das Ziel je Kerbe ist bis zur P7-Umstellung inaktiv.",
	audit_gate_off_close_c: "Familie C ignoriert das Band: Die Hürde ist eine perfekte Anzeige (≥ {0} wird nie gelesen).",
	audit_why_close: "unter Band bei Anzeige {0}",
	audit_why_peek: "Blicke über Budget bei Anzeige {0}",
	audit_why_perfect: "nicht perfekt bei Anzeige {0}",
	audit_why_void: "nirgends versiegelt — {0} von {1} gezeigt",
	audit_why_pass: "bestanden bei Anzeige {0}",
	audit_why_unknown: "versiegelt bei Anzeige {0} — Familie nicht erfasst",
	audit_v2_title: "v2 (Schatten)",
	audit_v2_sealedAt: "Versiegelt bei",
	audit_v2_evid_col_seq: "#",
	audit_v2_evid_col_perfect: "Perfekt",
	audit_v2_evid_col_sim: "Beleg-Sim",
	audit_v2_evid_col_veto: "Veto",
	audit_v2_guardFlags: "Schutz-Flags",
	audit_v2_gradedCut: "Gestufte Schwelle",
	// The strictness slider's live caption
	strictness_captionN1: "Die Lösung darf bis zu zweimal erscheinen, danach aus dem Gedächtnis tippen — sehr grobe Schreibweise genügt",
	strictness_captionN2: "Die Lösung darf einmal erscheinen, danach aus dem Gedächtnis tippen — sehr grobe Schreibweise genügt",
	strictness_captionN3: "Die Lösung darf einmal erscheinen, danach aus dem Gedächtnis tippen — grobe Schreibweise genügt",
	strictness_captionN4: "Das Wort ungefähr richtig tippen, bevor die Lösung erscheint — einmal",
	strictness_captionN5: "Das Wort nahezu richtig tippen, bevor die Lösung erscheint — zweimal",
	strictness_captionN6: "Das Wort fast genau tippen, bevor die Lösung erscheint — zweimal",
	strictness_captionN7: "Das Wort genau tippen, bevor der Countdown abläuft — zweimal",
	strictness_captionN8: "Das Wort genau tippen, bevor der Countdown abläuft — dreimal",
	strictness_captionN9: "Das Wort genau tippen, bevor der Countdown abläuft — dreimal hintereinander",
	strictness_captionN10: "Das Wort genau tippen, bevor der Countdown abläuft — jedes einzelne Mal, ganz ohne Hilfe",
	// Part-of-speech labels (pos_label.js) -- pos_label.js real.
	posNoun_label: "Nomen",
	posNoun_tooltip: "Nomen",
	posVerb_label: "Verb",
	posVerb_tooltip: "Verb",
	posAdjective_label: "Adj",
	posAdjective_tooltip: "Adjektiv",
	posAdverb_label: "Adv",
	posAdverb_tooltip: "Adverb",
	posPhrase_label: "Wend",
	posPhrase_tooltip: "Wendung",
	posPhraseVerbConj_label: "Vform",
	posPhraseVerbConj_tooltip: "konjugierte Verbform",
	posVerbForms_label: "Formen",
	posVerbForms_tooltip: "Stammformen des Verbs",
	posPreposition_label: "Präp",
	posPreposition_tooltip: "Präposition",
	posPronoun_label: "Pron",
	posPronoun_tooltip: "Pronomen",
	posConjunction_label: "Konj",
	posConjunction_tooltip: "Konjunktion",
	posInterjection_label: "Intrj",
	posInterjection_tooltip: "Interjektion",
	posNumeral_label: "Num",
	posNumeral_tooltip: "Zahlwort",
	posArticle_label: "Art",
	posArticle_tooltip: "Artikel",
	posDeterminer_label: "Det",
	posDeterminer_tooltip: "Determinativ",
	posAbbreviation_label: "Abk",
	posAbbreviation_tooltip: "Abkürzung",
	posParticle_label: "Part",
	posParticle_tooltip: "Partikel",
	posPrefix_label: "Präf",
	posPrefix_tooltip: "Präfix",
	// Form kinds (word_form rows) -- pos_label.js real.
	posPlural_label: "Pl",
	posPlural_tooltip: "Plural",
	posGenitiveSg_label: "Gen",
	posGenitiveSg_tooltip: "Genitiv Singular",
	posDeclined_label: "dekl",
	posDeclined_tooltip: "deklinierte Form",
	posPast_label: "Verg",
	posPast_tooltip: "Vergangenheitsform",
	posPreterite_label: "Prät",
	posPreterite_tooltip: "Präteritum (einfache Vergangenheit)",
	posPastParticiple_label: "Part",
	posPastParticiple_tooltip: "Partizip II",
	posPresent1Sg_label: "1Sg",
	posPresent1Sg_tooltip: "Präsens, 1. Person Singular",
	posPresent2Sg_label: "2Sg",
	posPresent2Sg_tooltip: "Präsens, 2. Person Singular",
	posPresent3Sg_label: "3Sg",
	posPresent3Sg_tooltip: "Präsens, 3. Person Singular",
	posImperative_label: "Imp",
	posImperative_tooltip: "Imperativ",
	posSubjunctiveII_label: "Konj2",
	posSubjunctiveII_tooltip: "Konjunktiv II",
	posSeparableParticle_label: "trenn",
	// English placeholder, tracking resources_en.js — ⛔ was 'separable prefix', which named the
	// wrong half of the verb (the row is the finite verb form, not the prefix).
	posSeparableParticle_tooltip: "trennbare Form",
	posComparative_label: "Komp",
	posComparative_tooltip: "Komparativ",
	posSuperlative_label: "Sup",
	posSuperlative_tooltip: "Superlativ",
	posIngForm_label: "-ing",
	posIngForm_tooltip: "-ing-Form",
	posContraction_label: "Kontr",
	posContraction_tooltip: "Kontraktion",
	posSuppletive_label: "Supp",
	posSuppletive_tooltip: "suppletive Form",
	posProperNoun_label: "Eig",
	posProperNoun_tooltip: "Eigenname",
	posSpellingVariant_label: "Var",
	posSpellingVariant_tooltip: "Schreibvariante",
	posFusion_label: "Fus",
	posFusion_tooltip: "verschmolzene Form",
	posOther_label: "sonst",
	posOther_tooltip: "Sonstiges"
};
